/* ==========================================================================
   Blue Bathware: ADP vanity Configurator                              v1.4.2
   --------------------------------------------------------------------------
   1.4.2: the "RRP / You save" line under the total only shows when the
   section setting "Show RRP and You save under the total" is on (off by
   default). Struck-through prices on single options are unchanged.
   --------------------------------------------------------------------------
   Works with sections/adp-vanity-configurator.liquid. It reads three things:
     1. the product and its variants      (printed by the section, from Shopify)
     2. the add-on catalogue, keyed by SKU (printed by the section, from Shopify)
     3. the range data file                (assets/adp-vanity-configurator-<range>.json)
   Prices, stock and variant ids always come from Shopify. The range data only
   says which choices exist and which ADP code each choice maps to.
   Nothing in this file is specific to one ADP range: a new range is a new data
   file, not new code. Besides the fixed steps, a range data file can add:
     picks    no-charge choices that go on the vanity's cart line (handles,
              drawer side, hinge side), each its own step
     extras   priced optional add-ons that become their own cart lines (infills)
     tapBowl  tap-hole options limited by bowl position
   and, since 1.4, describe ranges that are not a cabinet with a benchtop:
     tops with the basin moulded in (no colour, no basin step), a single fixed
     top (no top step), sizes that are not a width, a finish that brings its
     own choice of cabinet fronts, and choices that pick the variant.

   The dialog lives in a shadow root, so the theme's CSS cannot change it and
   its CSS cannot leak into the theme. No theme file is edited by this script.
   If anything it needs is missing, it steps aside and the standard product
   form is shown again.
   ========================================================================== */
(function () {
  'use strict';

  if (window.BBVB && window.BBVB.version) return;          // the file was included twice

  var VERSION = '1.4.2';
  var FORM_BLOCK = '.product-block--form';                   // Turbo's product form block
  var HOST_Z = '2147483000';
  var T_DATA = 8000, T_CART_ADD = 20000, T_CART_READ = 10000, T_OPEN = 10000;   // time limits, in ms

  var BOWLS = [
    { id: 'C', n: 'Centre', xs: [0.5] },
    { id: 'L', n: 'Left offset', xs: [0.3] },
    { id: 'R', n: 'Right offset', xs: [0.7] },
    { id: 'D', n: 'Double', xs: [0.27, 0.73] }
  ];
  var STEPS = [
    { id: 'size', l: 'Size', h: 'Choose your size' },
    { id: 'top', l: 'Benchtop', h: 'Choose your benchtop' },
    { id: 'thick', l: 'Benchtop thickness', h: 'Choose your benchtop thickness' },
    { id: 'fin', l: 'Cabinet finish', h: 'Choose your cabinet finish' },
    { id: 'front', l: 'Cabinet fronts', h: 'Choose your cabinet fronts' },      // only after a finish that can have classic fronts
    { id: 'basin', l: 'Basin', h: 'Choose your basin' },
    { id: 'tap', l: 'Tap holes', h: 'Choose your tap holes' },
    { id: 'waste', l: 'Plug & waste', h: 'Choose your plug & waste' },
    { id: 'power', l: 'Power point', h: 'Add a power point' },
    { id: 'kit', l: 'Plumbing kit', h: 'Add a plumbing kit' },
    { id: 'review', l: 'Review', h: 'Review your vanity' }
  ];
  var SEC_OF = { size: 'size', bowl: 'size', hinge: 'size', top: 'top', colour: 'top', thick: 'thick', fin: 'fin', front: 'front', basin: 'basin', bcol: 'basin',
    tap: 'tap', waste: 'waste', power: 'power', side: 'power', kit: 'kit' };   // which step each choice belongs to
  var OWN_STEP = { pick: 1, pcol: 1, pq: 1, ex: 1, exq: 1, exnone: 1 };   // choices of a step the range data defines: the step id leads the value ("handle|12")
  function secOf(name, value) { return OWN_STEP[name] ? String(value == null ? '' : value).split('|')[0] : SEC_OF[name]; }

  /* ---------- one Configurator per page ---------- */
  var CFG = null;        // what the section printed
  var SET = {};          // section settings
  var LIB = null;        // range library (swatches, basin list, tap options)
  var TOPK = {};         // kind of each top: 'b' benchtop (colour, basin, thickness), 'm' basin moulded in, 'n' none (cabinet only)
  var M = null;          // this product, assembled from the range data and Shopify
  var CAT = {};          // add-on catalogue by SKU
  var S = null;          // the customer's choices
  var sectionEl = null, launchEl = null, launchProto = null, noteEl = null, nativeEl = null;
  var host = null, shadow = null, root = null;
  var isOpen = false, lastFocus = null, inerted = [], bodyWatch = null, savedOverflow = null, sweepTimers = [];
  var pushed = false, backPending = false, pushAfterBack = false, traversing = false, backTimer = null;
  var cssReady = Promise.resolve(true);
  var readyResolve = null;
  var ready = new Promise(function (res) { readyResolve = res; });
  var failed = false;
  var INK = '#415366';
  var FILES = '';
  var MONEY = '${{amount}}';
  var generation = 0;    // goes up on every init, so late answers from an old init are ignored
  var mq = window.matchMedia ? window.matchMedia('(max-width: 899px)') : null;

  /* ---------- small helpers ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function delimit(cents, precision, thousands, decimal) {
    var parts = (Math.abs(Math.round(cents)) / 100).toFixed(precision).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }
  function money(cents) {                                    // Shopify's money formats, nothing else
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(MONEY), v;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = delimit(cents, 0, '.', ','); break;
      default: v = delimit(cents, 2, ',', '.');
    }
    return (cents < 0 ? '\u2212' : '') + (m ? MONEY.replace(m[0], v) : '$' + v);
  }
  function sized(u, w, h) {                                  // Shopify CDN: ask for the size we show
    if (!u) return '';
    var base = String(u).split('#')[0], q = '', i = base.indexOf('?');
    if (i > -1) { q = base.slice(i + 1); base = base.slice(0, i); }
    var keep = q.split('&').filter(function (p) { return p && !/^(width|height|crop)=/.test(p); });
    keep.push('width=' + w);
    if (h) { keep.push('height=' + h); keep.push('crop=center'); }
    return base + '?' + keep.join('&');
  }
  function file(name) { return name ? FILES + name : ''; }
  function img(src, alt) {
    return src ? '<img loading="lazy" decoding="async" alt="' + esc(alt || '') + '" src="' + esc(src) + '">' : '';
  }
  function str(v) { return typeof v === 'string' ? v : null; }                                   // a choice arrives from a click, the API or storage:
  function idx(v) {                                                                              // only plain strings and whole numbers are accepted
    if (typeof v === 'number') return isFinite(v) && v >= 0 && Math.floor(v) === v ? v : null;
    return typeof v === 'string' && /^\d{1,6}$/.test(v) ? +v : null;
  }
  function byId(list, id) { for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i]; return null; }
  function byCode(list, c) { for (var i = 0; i < list.length; i++) if (list[i].c === c) return list[i]; return null; }
  function buyable(sku) { var k = CAT[sku]; return !!(k && k.id && k.a !== false); }
  function warn(msg) { if (window.console && console.warn) console.warn('[Configurator] ' + msg); }
  function $(sel) { return root.querySelector(sel); }
  function request(url, opts, ms) {      // fetch with a time limit; resolves {status, okHttp, data, network}, never rejects, never hangs
    var ctl = window.AbortController ? new AbortController() : null;
    var lost = { status: 0, okHttp: false, data: null, network: true };
    opts = opts || {};
    if (ctl) opts.signal = ctl.signal;
    return new Promise(function (resolve) {
      var timer = window.setTimeout(function () {            // the limit holds even if another script has wrapped fetch
        if (ctl) { try { ctl.abort(); } catch (e) {} }
        resolve(lost);
      }, ms);
      function done(x) { window.clearTimeout(timer); resolve(x); }
      try {
        fetch(url, opts).then(function (r) {
          return r.text().then(function (txt) {
            var data = null;
            try { data = JSON.parse(txt); } catch (e) {}
            done({ status: r.status, okHttp: r.ok, data: data });
          });
        }).catch(function () { done(lost); });
      } catch (e) { done(lost); }
    });
  }

  /* ---------- assemble this product from the range data and Shopify ---------- */
  function assemble(data) {
    // A data file that needs the steps added in 1.3 keeps its products under "products@1.3". A script older than that
    // finds no products in it and hands the page back to the standard form, instead of running the builder without those steps.
    // The same goes for 1.4: a file that needs moulded tops, fixed tops or the other 1.4 additions keeps its products under "products@1.4".
    var prods = data ? (data.products || data['products@1.3'] || data['products@1.4']) : null;
    var R = prods ? prods[CFG.product.handle] : null;
    if (!data || !data.lib || !R) throw new Error('this product (' + CFG.product.handle + ') is not in the range data file');
    LIB = data.lib;
    if (!Array.isArray(LIB.topGroups) || !Array.isArray(LIB.tops) || !Array.isArray(LIB.fins) || !Array.isArray(LIB.basins) || !Array.isArray(LIB.taps)) throw new Error('the range data file is incomplete');
    if (LIB.refs && typeof LIB.refs === 'object') {          // a block several products share is stored once and named "@x"
      var whole_ = {}, rk;
      for (rk in R) whole_[rk] = (typeof R[rk] === 'string' && R[rk].charAt(0) === '@' && own(LIB.refs, R[rk].slice(1))) ? LIB.refs[R[rk].slice(1)] : R[rk];
      R = whole_;
    }
    function setOf(v) { return typeof v === 'string' ? (LIB.sets && own(LIB.sets, v) && Array.isArray(LIB.sets[v]) ? LIB.sets[v] : null) : v; }   // a named list of indexes
    TOPK = Object.create(null);
    LIB.topGroups.forEach(function (g) { if (g && typeof g.id === 'string') TOPK[g.id] = g.k === 'm' || g.k === 'n' || g.k === 'b' ? g.k : (g.id === 'NT' ? 'n' : 'b'); });

    var variants = {};
    (CFG.product.variants || []).forEach(function (v) { if (v && v.sku && !variants[v.sku]) variants[v.sku] = v; });

    var oos = {};
    (LIB.oos || []).forEach(function (c) { oos[c] = 1; });
    var basinInfo = LIB.basins.map(function (b) {
      var k = CAT[b.c];
      return {
        c: b.c, g: b.g, k: k || null, oos: !!oos[b.c],
        ok: buyable(b.c),
        fam: k ? String(k.t || '').replace(/^ADP\s+/i, '').replace(/\s+Basin$/i, '') : b.c,
        col: k && k.v && k.v !== 'Default Title' ? String(k.v).replace(/\s+-\s+[A-Za-z -]*Basins?$/i, '') : '',      // the store names some colours "Gloss White - Semi-Inset Basins": the mounting is said elsewhere
        key: b.g + '|' + (k ? k.h : b.c)
      };
    });

    function text(v, alt) { return typeof v === 'string' && v ? v : (alt || ''); }
    function whole(n) { return typeof n === 'number' && isFinite(n) && n >= 0 && Math.floor(n) === n; }
    function words(a) { return (Array.isArray(a) ? a : []).filter(function (o) { return typeof o === 'string' && !!o; }); }
    var m = {
      title: CFG.product.title || R.title || '', depth: R.depth || '', mount: R.mount || '',
      combos: Object.create(null), sizes: [], basins: basinInfo,
      hero: R.hero && +R.hero.z > 1 ? { z: +R.hero.z, oy: +R.hero.oy || 50 } : null,
      hinge: R.hinge && R.hinge.sizes && R.hinge.opts ? R.hinge : null,
      powerNote: R.powerNote || '',
      vary: text(R.vary) || null,                            // the choice that picks between variants of one size, bowl and top ('basin' or a pick's id)
      sizeL: R.sizeL && typeof R.sizeL === 'object' ? R.sizeL : null, sizeHead: text(R.sizeHead), bowlL: R.bowlL && typeof R.bowlL === 'object' ? R.bowlL : null, bowlHead: text(R.bowlHead),
      std: R.std && typeof R.std === 'object' ? R.std : null, cols: R.cols && typeof R.cols === 'object' ? R.cols : null,
      finNo: R.finNo && typeof R.finNo === 'object' ? R.finNo : null, noPlan: !!R.noPlan,
      topNote: R.topNote && typeof R.topNote === 'object' ? R.topNote : null, tapHelp: text(R.tapHelp), facts: words(R.facts)
    };

    var topSeen = Object.create(null), bowlSeen = Object.create(null);
    Object.keys(R.combos || {}).forEach(function (key) {
      var c = R.combos[key], tops = Object.create(null), any = false, parts = key.split('|'), size = idx(parts[0]), bowl = parts[1];
      if (!c || size == null || !byId(BOWLS, bowl)) return;
      var codes = c.tops;
      if (!codes && typeof c.s === 'string' && typeof c.t === 'string') {      // every code is the stem plus the top's letters
        codes = {};
        c.t.split(' ').forEach(function (t) { if (t) codes[t] = c.s + t; });
      }
      Object.keys(codes || {}).forEach(function (t) {
        if (!byId(LIB.topGroups, t)) return;
        var many = Array.isArray(codes[t]);
        var list = (many ? codes[t] : [codes[t]]).map(function (sku) { var v = variants[sku]; return v && v.available !== false ? v : null; });
        if (!list.some(Boolean)) return;
        tops[t] = many ? list : list[0]; topSeen[t] = 1; any = true;
      });
      if (!any) return;
      var idx_ = [], mask = typeof c.mask === 'number' ? (Array.isArray(LIB.masks) ? LIB.masks[c.mask] : '') : c.mask;
      if (typeof mask === 'string' && mask) {
        var bits = '';
        for (var i = 0; i < mask.length; i++) bits += ('000' + parseInt(mask.charAt(i), 16).toString(2)).slice(-4);
        for (var j = 0; j < basinInfo.length; j++) if (bits.charAt(j) === '1' && basinInfo[j].k) idx_.push(j);
      }
      m.combos[key] = { key: key, size: size, w: c.w, h: c.h, d: c.d, nb: c.nb || 1, cols: c.cols || 1, kitInc: !!c.kitInc, anyNT: !!c.anyNT, bowl: bowl, tops: tops, basins: idx_ };
      bowlSeen[bowl] = 1;
      if (m.sizes.indexOf(size) < 0) m.sizes.push(size);
    });
    m.sizes.sort(function (a, b) { return a - b; });
    if (!m.sizes.length) throw new Error('none of this product\u2019s variants match the range data by SKU, or none is available');
    m.topIds = LIB.topGroups.filter(function (g) { return !!topSeen[g.id]; }).map(function (g) { return g.id; });
    m.hasMoulded = m.topIds.some(function (t) { return TOPK[t] === 'm'; });
    m.oneBowl = Object.keys(bowlSeen).length === 1;          // the bowl sits in one place on every size: nothing to ask
    m.one = m.sizes.length === 1 && Object.keys(m.combos).length === 1 ? m.combos[Object.keys(m.combos)[0]] : null;   // one size, one bowl position: nothing to ask

    var finList = setOf(R.fins);
    m.fins = (Array.isArray(finList) ? finList : LIB.fins.map(function (f, i) { return i; })).filter(function (i) { return whole(i) && !!LIB.fins[i]; });
    m.fronts = null;                                         // a choice of cabinet fronts that only some finishes can have, at one charge
    if (SET.classic_fronts !== false && R.fronts && typeof R.fronts.c === 'string' && buyable(R.fronts.c) && Array.isArray(R.fronts.fg) && Array.isArray(R.fronts.items)) {
      var fronts = R.fronts.items.filter(function (it) { return !!it && typeof it.n === 'string' && !!it.n; }).map(function (it) {
        return { n: it.n, img: typeof it.f === 'string' && it.f ? file(it.f) : '' };
      });
      if (fronts.length) m.fronts = { c: R.fronts.c, k: CAT[R.fronts.c], fg: R.fronts.fg, w: text(R.fronts.w), items: fronts };   // w: which finishes, in words ("Matte polyurethane")
    }
    m.wastes = (R.wastes || []).filter(function (w) { return w.inc || buyable(w.c); }).map(function (w) {
      var k = CAT[w.c];
      return { c: w.c, n: w.n, inc: !!w.inc, k: k || null, img: w.f ? file(w.f) : (k ? k.img : '') };
    });
    m.thick = (R.thick || []).filter(function (t) { return buyable(t.c); }).map(function (t) {
      return { id: t.id, c: t.c, n: t.n, mm: t.mm, tops: t.tops || [], img: file(t.f), k: CAT[t.c] };
    });
    m.power = (R.power || []).filter(function (p) { return buyable(p.c); }).map(function (p) {
      return { c: p.c, n: p.n, k: CAT[p.c], img: CAT[p.c].img };
    });
    m.wasteAuto = m.wastes.length === 1 && m.wastes[0].inc;   // one plug & waste, and it is included: nothing to ask
    m.kit = R.kit && buyable(R.kit.c) ? { c: R.kit.c, n: R.kit.n, k: CAT[R.kit.c] } : null;
    m.incBasin = R.incBasin && R.incBasin.length ? R.incBasin.map(function (b) {
      var pic = CAT[b.c] || CAT[b.pic];                      // "pic": the SKU whose picture shows this basin, when ADP gives the included basin no code of its own
      return { c: text(b.c), n: b.n, type: b.type || '', img: pic ? pic.img : '' };
    }) : null;
    function tapList(ids) { return (Array.isArray(ids) ? ids : []).map(function (id) { return byId(LIB.taps, id); }).filter(Boolean); }
    m.tapTop = null;                                         // tap-hole options that depend on the top: { top id: [...] }, with m.taps for every other top
    if (R.taps && typeof R.taps === 'object' && !Array.isArray(R.taps)) {
      m.taps = tapList(R.taps['*']);
      m.tapTop = Object.create(null);
      Object.keys(R.taps).forEach(function (t) { if (t !== '*') m.tapTop[t] = tapList(R.taps[t]); });
      m.topIds.forEach(function (t) { if (!m.tapTop[t] && !own(R.taps, '*')) m.tapTop[t] = []; });
    } else m.taps = tapList(R.taps);
    m.tapBowl = R.tapBowl && typeof R.tapBowl === 'object' ? R.tapBowl : null;
    m.tapNote = typeof R.tapNote === 'string' ? R.tapNote : '';
    m.powerAsk = null;                                       // which drawer the power point goes in, when the order form asks: { opts, sizes: { size: opts } }
    if (R.powerAsk && Array.isArray(R.powerAsk.opts)) {
      var bySize = Object.create(null);
      if (R.powerAsk.sizes && typeof R.powerAsk.sizes === 'object') Object.keys(R.powerAsk.sizes).forEach(function (sz) { bySize[sz] = words(R.powerAsk.sizes[sz]); });
      m.powerAsk = { opts: words(R.powerAsk.opts), sizes: bySize };
    }

    // steps the range data adds: no-charge choices (picks) and priced extras
    var taken = {};
    STEPS.forEach(function (s) { taken[s.id] = 1; });
    function stepId(x) {
      var ok = !!x && typeof x.id === 'string' && /^[a-z][a-z0-9]{0,15}$/.test(x.id) && !taken[x.id];
      if (ok) taken[x.id] = 1;
      return ok;
    }
    function propName(v, alt) { v = text(v, alt); return v === '__proto__' ? alt : v; }
    m.picks = (Array.isArray(R.picks) ? R.picks : []).filter(stepId).map(function (p) {
      var list = null, items = null, opts = null, label = text(p.l, p.id), fee = null, given;
      if (p.fee && typeof p.fee.c === 'string' && buyable(p.fee.c) && whole(p.fee.min) && whole(p.fee.max) && p.fee.min >= 1 && p.fee.max >= p.fee.min && p.fee.max <= 40) {
        // some of the choices cost extra, charged for each one fitted: the customer says how many (premium handles)
        fee = { c: p.fee.c, k: CAT[p.fee.c], min: p.fee.min, max: p.fee.max, l: text(p.fee.l, 'How many?'), note: text(p.fee.note), need: text(p.fee.need, 'how many you need'), each: text(p.fee.each, 'each') };
      }
      if (p.lib) {
        list = Array.isArray(LIB[p.lib]) ? LIB[p.lib] : [];
        given = setOf(p.items);
        items = (Array.isArray(given) ? given : list.map(function (x, i) { return i; })).filter(function (i) {
          return whole(i) && !!list[i] && typeof list[i].s === 'string' && !!list[i].s && (!list[i].pr || !!fee);   // a choice that costs extra is only offered when its charge can be bought
        });
      } else if (Array.isArray(p.opts)) {
        opts = p.opts.filter(function (o) { return typeof o === 'string' && !!o; });
      }
      var has = items ? items.length > 0 : !!(opts && opts.length > 1);
      if (!has && p.req) throw new Error('the "' + p.id + '" choices in the range data file could not be read');   // never sell a vanity without a choice the order needs
      return {
        id: p.id, l: label, h: text(p.h, label), lede: text(p.lede), prop: propName(p.prop, label), req: !!p.req, after: text(p.after), note: text(p.note), unit: text(p.unit, 'option'),
        list: list, items: items, opts: opts, has: has, fee: fee, icon: text(p.icon),
        def: whole(p.def) && (items ? items.indexOf(p.def) > -1 : !!(opts && opts[p.def])) ? p.def : null, std: whole(p.std) ? p.std : null,
        sizes: Array.isArray(p.sizes) ? p.sizes : null, combos: Array.isArray(p.combos) ? p.combos : null,
        tops: Array.isArray(p.tops) ? p.tops : null, tk: Array.isArray(p.tk) ? p.tk : null     // only for these tops, or these kinds of top
      };
    }).filter(function (p) { return p.has; });
    if (m.vary && m.vary !== 'basin' && !m.picks.some(function (p) { return p.id === m.vary && !!p.opts; })) throw new Error('the choice that picks the variant ("' + m.vary + '") is missing from the range data file');
    if (m.vary === 'basin' && !m.incBasin) throw new Error('the included basin that picks the variant is missing from the range data file');
    m.extras = (Array.isArray(R.extras) ? R.extras : []).filter(stepId).map(function (x) {
      var label = text(x.l, x.id), seenC = Object.create(null);
      return {
        id: x.id, l: label, h: text(x.h, label), lede: text(x.lede), after: text(x.after),
        single: !!x.single, perBasin: !!x.perBasin, none: text(x.none, 'No extras'),      // single: one of them at most. perBasin: one for each basin
        items: (Array.isArray(x.items) ? x.items : []).filter(function (it) {
          if (!it || typeof it.c !== 'string' || seenC[it.c] || !buyable(it.c)) return false;
          seenC[it.c] = 1;
          return true;
        }).map(function (it) {
          var k = CAT[it.c];
          return {
            c: it.c, n: text(it.n, String(k.t || it.c)), d: text(it.d), k: k, img: typeof it.f === 'string' && it.f ? file(it.f) : k.img,
            x: Array.isArray(it.x) ? it.x.filter(function (c) { return typeof c === 'string'; }) : [],
            ask: (Array.isArray(it.ask) ? it.ask : []).map(function (q) {
              if (!q || typeof q.id !== 'string' || !/^[a-z][a-z0-9]{0,11}$/.test(q.id)) return null;
              var o = Array.isArray(q.opts) ? q.opts.filter(function (v) { return typeof v === 'string' && !!v && v.indexOf('|') < 0; }) : null;
              if (o ? o.length < 2 : !(whole(q.min) && whole(q.max) && q.max >= q.min && q.max - q.min <= 500)) return null;
              return { id: q.id, l: text(q.l, q.id), note: text(q.note), need: text(q.need, 'an option'), prop: propName(q.prop, text(q.l, q.id)), unit: text(q.unit), opts: o, min: q.min, max: q.max };
            }).filter(Boolean)
          };
        })
      };
    }).filter(function (x) { return x.items.length > 0; });
    m.steps = STEPS.slice(0, STEPS.length - 1).map(function (s) {      // a range can name a fixed step its own way: { step id: [label, heading] }
      var o = R.stepL && own(R.stepL, s.id) && Array.isArray(R.stepL[s.id]) ? R.stepL[s.id] : null;
      if (!o && s.id === 'top' && m.hasMoulded) o = ['Top', 'Choose your top'];      // not every top is a benchtop here
      if (!o && s.id === 'size' && m.sizes.length === 1) o = [m.bowlHead || 'Bowl position', 'Choose the ' + (m.bowlHead || 'bowl position').toLowerCase()];
      return o && typeof o[0] === 'string' && o[0] ? { id: s.id, l: o[0], h: typeof o[1] === 'string' && o[1] ? o[1] : s.h } : s;
    });
    m.picks.map(function (p) { return { id: p.id, l: p.l, h: p.h, after: p.after, pick: p }; }).concat(
      m.extras.map(function (x) { return { id: x.id, l: x.l, h: x.h, after: x.after, extra: x }; })).forEach(function (st) {
      var at = m.steps.length - 1, i, after = st.after === 'fin' ? 'front' : st.after;   // the fronts question belongs to the finish: nothing comes between the two
      for (i = 0; i < m.steps.length; i++) if (m.steps[i].id === after) at = i;
      m.steps.splice(at + 1, 0, st);                         // straight after the step it names, or last before the review
    });
    m.steps.push(STEPS[STEPS.length - 1]);

    m.dv = [data.v, data.asAt, LIB.tops.length, LIB.fins.length, LIB.basins.length, m.picks.map(function (p) { return p.id + (p.items || p.opts).length; }).join('.')].join('|');   // saved choices are only valid for this data
    if (m.fronts || m.hasMoulded || m.sizeL || m.vary) m.dv += '|' + [m.fronts ? m.fronts.items.length : 0, m.topIds.join('.'), m.sizes.join('.')].join('|');
    return m;
  }
  function loadCatalogue() {             // SKU -> add-on. The section prints it; if Liquid capped the list, fetch the rest
    CAT = {};
    (CFG.addons || []).forEach(function (a) { if (a && a.sku && !CAT[a.sku]) CAT[a.sku] = a; });
    var meta = CFG.addons_meta || {};
    if (!meta.url || !(meta.count > meta.printed)) return Promise.resolve();
    return request(String(meta.url).replace(/\/$/, '') + '/products.json?limit=250', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }, T_DATA).then(function (r) {
      var list = r.data && r.data.products;
      if (!r.okHttp || !list) { warn('The add-ons collection has ' + meta.count + ' products but only ' + meta.printed + ' could be read'); return; }
      function cents(x) { var n = Math.round(parseFloat(x) * 100); return isNaN(n) ? 0 : n; }
      list.forEach(function (p) {
        (p.variants || []).forEach(function (v) {
          if (!v || !v.sku || CAT[v.sku]) return;
          var pic = (v.featured_image && v.featured_image.src) || (p.images && p.images[0] && p.images[0].src) || '';
          CAT[v.sku] = { sku: v.sku, id: v.id, p: cents(v.price), cp: v.compare_at_price ? cents(v.compare_at_price) : 0, a: v.available !== false, t: p.title, v: v.title, h: p.handle, type: p.product_type, img: pic, dims: null };
        });
      });
      meta.printed = Math.max(meta.printed, list.length);
    });
  }

  /* ---------- state ---------- */
  function fresh() {
    var inc = M.wastes.filter(function (w) { return w.inc; })[0];
    var s = {
      step: 'size', size: null, bowl: null, hinge: null, top: null, colour: null, thick: 'std', fin: null, front: null,
      basin: null, tap: null, waste: inc ? inc.c : null, power: null, side: null, kit: false, ack: false, pk: Object.create(null), pq: Object.create(null), ex: Object.create(null),
      bf: 'all', notice: null, restored: false, sheet: false, busy: false, error: null, done: null, build: null, unsettled: null, seen: {}
    };
    if (M.one) { s.size = M.one.size; s.bowl = M.one.bowl; }  // nothing to ask: one size, one bowl position
    else if (M.sizes.length === 1) s.size = M.sizes[0];      // one size: only the bowl position is asked
    var keep = S;
    S = s;                                                   // the helpers below read S
    settle();
    s.step = activeSteps()[0].id;
    s.seen[s.step] = 1;
    S = keep;
    return s;
  }
  function settle() {                    // a question with one possible answer is answered for the customer
    var ts, fl;
    if (S.size != null && !S.bowl) { var bs = bowlsFor(S.size); if (bs.length === 1) S.bowl = bs[0].id; }
    if (combo() && !S.top) {
      ts = topsAvailable();
      if (ts.length === 1 && !topColours(ts[0].id).length) S.top = ts[0].id;
    }
    fl = finsFor();
    if (S.fin != null && fl.indexOf(S.fin) < 0) { S.fin = null; S.front = null; }
    if (S.fin == null && fl.length === 1) S.fin = fl[0];
    if (S.front != null && !frontsOn()) S.front = null;
  }
  function topKind(t) { return TOPK[t] || 'b'; }
  function topColours(t) {               // indexes of the colours this product's top comes in (none for a moulded top or cabinet only)
    var only = M.cols && Array.isArray(M.cols[t]) ? M.cols[t] : null, out = [];
    LIB.tops.forEach(function (c, i) { if (c && c.g === t && (!only || only.indexOf(i) > -1)) out.push(i); });
    return out;
  }
  function incBasinIndex() { return typeof S.basin === 'string' && S.basin.charAt(0) === 'i' ? +S.basin.slice(1) : -1; }
  function pickById(id) { for (var i = 0; i < M.picks.length; i++) if (M.picks[i].id === id) return M.picks[i]; return null; }
  function varyIndex() {                 // which of several variants of one size, bowl and top the customer's choice picks (null: not chosen yet)
    if (!M.vary) return null;
    if (M.vary === 'basin') { var ii = incBasinIndex(); return ii > -1 ? ii : null; }
    var p = pickById(M.vary), v = p ? pickVal(p) : null;
    return v == null ? null : v;
  }
  function oneOf(x, at) {                // x: a variant, or the list a choice picks from
    if (!Array.isArray(x)) return x || null;
    if (at != null) return x[at] || null;
    var best = null;
    x.forEach(function (v) { if (v && (!best || v.price < best.price)) best = v; });
    return best;                         // not chosen yet: the cheapest, for the "from" price and the picture
  }
  function combo() { return S.size != null && S.bowl ? M.combos[S.size + '|' + S.bowl] || null : null; }
  function variantFor(size, bowl, topId) { var c = M.combos[size + '|' + bowl]; return c ? oneOf(c.tops[topId], varyIndex()) || (M.vary ? oneOf(c.tops[topId], null) : null) : null; }
  function variant() {
    if (S.size == null || !S.bowl || !S.top) return null;
    var c = combo();
    return c ? oneOf(c.tops[S.top], M.vary && Array.isArray(c.tops[S.top]) ? varyIndex() : null) : null;
  }
  function varyHas(i) {                  // is there a variant for that answer, with the size, bowl and top chosen so far?
    var c = combo(), x = c && S.top ? c.tops[S.top] : null;
    return !Array.isArray(x) || !!x[i];
  }
  function baseVariant(size, bowl) {     // cheapest variant with a top; cabinet only when that is all there is
    var c = M.combos[size + '|' + bowl], best = null, bare = null;
    if (!c) return null;
    Object.keys(c.tops).forEach(function (t) {
      var v = oneOf(c.tops[t], null);
      if (!v) return;
      if (topKind(t) === 'n') { bare = v; return; }
      if (!best || v.price < best.price) best = v;
    });
    return best || bare;
  }
  function bowlsFor(size) { return BOWLS.filter(function (b) { return !!M.combos[size + '|' + b.id]; }); }
  function topsAvailable() { var c = combo(); return c ? LIB.topGroups.filter(function (g) { return !!c.tops[g.id]; }) : []; }
  function allowedBasins() { var c = combo(); return c ? c.basins : []; }
  function thickAllowed(t) { return !!S.top && t.tops.indexOf(S.top) > -1; }
  function sideOpts() {                  // the drawers a power point can go in, as the order form lists them
    var c = combo();
    if (!M.powerAsk) return c && c.cols > 1 ? ['Left', 'Right'] : [];
    return S.size != null && M.powerAsk.sizes[S.size] ? M.powerAsk.sizes[S.size] : M.powerAsk.opts;
  }
  function needsSide() { return !!S.power && sideOpts().length > 0; }
  function needsHinge() { return !!(M.hinge && S.size != null && M.hinge.sizes.indexOf(S.size) > -1); }
  function finsFor() {                   // some sizes cannot have every finish (an open-shelf unit has no polyurethane)
    if (!M.finNo || S.size == null) return M.fins;
    return M.fins.filter(function (i) { var no = M.finNo[LIB.fins[i].g]; return !(Array.isArray(no) && no.indexOf(S.size) > -1); });
  }
  function frontsOn() { return !!M.fronts && S.fin != null && !!LIB.fins[S.fin] && M.fronts.fg.indexOf(LIB.fins[S.fin].g) > -1 && !LIB.fins[S.fin].nf; }   // nf: a finish of that group that cannot have them (gloss)
  function stepDef(id) { for (var i = 0; i < M.steps.length; i++) if (M.steps[i].id === id) return M.steps[i]; return null; }
  function pickOn(p) {                   // some choices only exist for certain sizes, bowl positions or tops
    if (p.sizes && (S.size == null || p.sizes.indexOf(S.size) < 0)) return false;
    if (p.combos && (S.size == null || !S.bowl || p.combos.indexOf(S.size + '|' + S.bowl) < 0)) return false;
    if (p.tops && (!S.top || p.tops.indexOf(S.top) < 0)) return false;
    if (p.tk && (!S.top || p.tk.indexOf(topKind(S.top)) < 0)) return false;
    return true;
  }
  function feeOn(p) { var v = pickVal(p); return !!(p.fee && p.list && v != null && p.list[v] && p.list[v].pr); }   // the chosen one costs extra, for each one fitted
  function started() {                   // has the customer chosen anything yet?
    if (M.sizes.length > 1) return S.size != null;       // every build starts with the size
    var f = fresh(), i;
    for (i = 0; i < KEEP.length; i++) if (JSON.stringify(S[KEEP[i]]) !== JSON.stringify(f[KEEP[i]])) return true;
    return false;
  }
  function pickVal(p) { var v = S.pk[p.id]; return typeof v === 'number' ? v : p.def; }
  function pickLabel(p) {
    var v = pickVal(p), it;
    if (v == null) return '';
    if (p.opts) return p.opts[v] || '';
    it = p.list[v];
    return it ? it.s + (it.n ? ' ' + it.n : '') : '';
  }
  function pickStyle(p, v) {             // every finish of one style, from this product's list
    var it = v == null ? null : p.list[v];
    return it ? p.items.filter(function (i) { return p.list[i].s === it.s; }) : [];
  }
  function extraChosen(x) { var e = S.ex[x.id] || {}; return x.items.filter(function (it) { return !!e[it.c]; }); }
  function extraAnswer(x, it, q) { var e = (S.ex[x.id] || {})[it.c]; return e && e[q.id] != null ? e[q.id] : null; }
  function extraLabel(x, it) {
    var bits = it.ask.map(function (q) {
      var a = extraAnswer(x, it, q);
      return a == null ? '' : (q.opts ? String(a).toLowerCase() : a + (q.unit || ''));
    }).filter(Boolean);
    return it.n + (bits.length ? ' (' + bits.join(', ') + ')' : '');
  }
  function extraProblem(x) {
    var list = extraChosen(x), i, j, q;
    for (i = 0; i < list.length; i++) for (j = 0; j < list[i].ask.length; j++) {
      q = list[i].ask[j];
      if (extraAnswer(x, list[i], q) == null) return 'Choose ' + (q.need || 'an option') + ' for the ' + list[i].n.toLowerCase();
    }
    return '';
  }
  function tapsOf(top) {                 // the tap-hole options of one top; some order forms also tie the tap hole to the bowl position
    var lim = M.tapBowl && S.bowl ? M.tapBowl[S.bowl] : null;
    var list = M.tapTop && M.tapTop[top] ? M.tapTop[top] : M.taps;
    return list.filter(function (t) { return !Array.isArray(lim) || lim.indexOf(t.id) > -1; });
  }
  function tapsFor() { return tapsOf(S.top); }
  function activeSteps() {
    var c = combo();
    var judge = S.top ? [S.top] : (c ? topsAvailable().map(function (g) { return g.id; }) : M.topIds);   // until a top is chosen, a step shows if any top could need it
    function any(test) { return judge.some(function (t) { return topKind(t) !== 'n' && test(t); }); }
    return M.steps.filter(function (s) {
      if (s.pick) return pickOn(s.pick);
      if (s.extra) return true;
      switch (s.id) {
        case 'size': return !M.one;
        case 'top': return !(M.topIds.length === 1 && !topColours(M.topIds[0]).length);   // one top and nothing to choose about it
        case 'thick': return M.thick.length > 0 && any(function (t) { return topKind(t) === 'b'; });
        case 'fin': return finsFor().length > 1;
        case 'front': return frontsOn();
        case 'basin': return any(function (t) { return topKind(t) === 'b'; });      // a benchtop always needs an answer, even where ADP lists no basin to suit
        case 'tap': return any(function (t) { return tapsOf(t).length > 0; });
        case 'waste': return M.wastes.length > 0 && !M.wasteAuto && any(function () { return true; });
        case 'power': return M.power.length > 0;
        case 'kit': return !!M.kit && !(c && c.kitInc);
      }
      return true;
    });
  }
  function stepIndex(id) { var a = activeSteps(); for (var i = 0; i < a.length; i++) if (a[i].id === id) return i; return -1; }
  function stepOn(id) { return stepIndex(id) > -1; }

  function problem(id) {                 // why a step is not finished yet ('' when it is)
    switch (id) {
      case 'size':
        if (S.size == null) return M.sizeL ? 'Choose a size' : 'Choose a width';
        if (!S.bowl) return M.bowlHead ? 'Choose the ' + M.bowlHead.toLowerCase() : 'Choose a bowl position';
        return needsHinge() && !S.hinge ? 'Choose the door hinge side' : '';
      case 'top':
        if (!S.top) return M.hasMoulded ? 'Choose a top' : 'Choose a benchtop material';
        return topColours(S.top).length && S.colour == null ? (M.hasMoulded ? 'Choose a colour for the top' : 'Choose a benchtop colour') : '';
      case 'fin': return S.fin == null ? 'Choose a cabinet finish' : '';
      case 'basin': return S.basin == null ? (M.incBasin ? 'Choose a basin colour' : (allowedBasins().length || !combo() ? 'Choose a basin, or No basin,' : 'Confirm No basin')) : '';
      case 'tap': return !S.tap ? 'Choose a tap hole option' : '';
      case 'waste': return !S.waste ? 'Choose a plug & waste finish' : '';
      case 'power': return needsSide() && !S.side ? 'Choose which drawer the power point goes in' : '';
      case 'review':
        var a = activeSteps();
        for (var i = 0; i < a.length - 1; i++) { var p = problem(a[i].id); if (p) return p; }
        return SET.require_ack && !S.ack ? 'Tick the made-to-order box' : '';
    }
    var st = stepDef(id);
    if (st && st.pick) {
      if (st.pick.req && pickVal(st.pick) == null) return 'Choose your ' + st.pick.l.toLowerCase();
      return feeOn(st.pick) && S.pq[st.pick.id] == null ? 'Choose ' + st.pick.fee.need : '';
    }
    if (st && st.extra) return extraProblem(st.extra);
    return '';
  }
  function reachable(id) {               // every earlier step must be finished
    var a = activeSteps();
    for (var i = 0; i < a.length; i++) {
      if (a[i].id === id) return true;
      if (problem(a[i].id)) return false;
    }
    return false;
  }
  function required(id) {                // a step with no default: the customer has to choose
    if (id === 'waste') return !M.wastes.some(function (w) { return w.inc; });
    var st = stepDef(id);
    if (st && st.pick) return st.pick.req && st.pick.def == null;
    if (st && st.extra) return false;
    return id === 'size' || id === 'top' || id === 'fin' || id === 'basin' || id === 'tap';
  }
  function familyOf(i) {                 // the colours of one basin that fit this size
    var b = M.basins[i];
    return b ? allowedBasins().filter(function (j) { return M.basins[j].key === b.key; }) : [];
  }
  function finishes(name, value) {       // was that click the last choice its step needs?
    var st, p;
    switch (name) {
      case 'pick': st = stepDef(secOf(name, value)); p = st && st.pick; return !p || ((!p.list || pickStyle(p, pickVal(p)).length < 2) && !(feeOn(p) && S.pq[p.id] == null));
      case 'pcol': st = stepDef(secOf(name, value)); p = st && st.pick; return !p || !(feeOn(p) && S.pq[p.id] == null);
      case 'pq': case 'exnone': return true;
      case 'size': return bowlsFor(S.size).length === 1 && !needsHinge();
      case 'bowl': return !needsHinge();
      case 'top': return !!S.top && !topColours(S.top).length;
      case 'basin': return typeof S.basin !== 'number' || familyOf(S.basin).length < 2;
      case 'power': return !needsSide();
      case 'hinge': case 'colour': case 'thick': case 'fin': case 'front': case 'bcol': case 'tap': case 'waste': case 'side': case 'kit': return true;
    }
    return false;
  }
  function nextOpen(from) {              // the next step that still needs the customer: unfinished, or not looked at yet
    var a = activeSteps(), i = stepIndex(from), j;
    for (j = i + 1; j < a.length; j++) if (j === a.length - 1 || problem(a[j].id) || !S.seen[a[j].id]) return a[j].id;
    return null;
  }
  function comboChanged(topOnly) {       // size, bowl or top changed: drop anything that no longer fits
    var c = combo(), hadFin = S.fin;
    if (c) {                             // a basin can only be judged once both are chosen
      if (typeof S.basin === 'number' && c.basins.indexOf(S.basin) < 0) {
        S.notice = 'The ' + M.basins[S.basin].fam + ' basin doesn\u2019t fit this size, so your basin choice was cleared.';
        S.basin = null;
      }
      if (!topOnly && S.bf !== 'all' && !c.basins.some(function (i) { return M.basins[i].g === S.bf; })) S.bf = 'all';
      if (S.top && !c.tops[S.top]) { S.top = null; S.colour = null; S.thick = 'std'; }
      if (M.vary === 'basin' && incBasinIndex() > -1 && !varyHas(incBasinIndex())) S.basin = null;
    }
    settle();
    if (hadFin != null && S.fin == null) S.notice = 'That cabinet finish isn\u2019t made in this size, so your finish choice was cleared.';
    if (needsSide() ? (S.side && sideOpts().indexOf(S.side) < 0) : true) S.side = null;
    if (!needsHinge()) S.hinge = null;
    M.picks.forEach(function (p) {
      if (!pickOn(p)) { delete S.pk[p.id]; delete S.pq[p.id]; }
      else if (M.vary === p.id && typeof S.pk[p.id] === 'number' && !varyHas(S.pk[p.id])) delete S.pk[p.id];
    });
    if (S.tap && !tapsFor().some(function (t) { return t.id === S.tap; })) S.tap = null;
  }

  /* ---------- labels, pricing, cart lines ---------- */
  function sizeText(sz) { return M.sizeL && typeof M.sizeL[sz] === 'string' && M.sizeL[sz] ? M.sizeL[sz] : sz + 'mm'; }
  function sizeLabel() { return sizeText(S.size); }
  function bowlText(id) {                // [name, line under it] for a bowl position; a range can word its own (a corner unit, a shelf beside the basin)
    var b = byId(BOWLS, id), own_ = M.bowlL && Array.isArray(M.bowlL[id]) ? M.bowlL[id] : null;
    return own_ && typeof own_[0] === 'string' && own_[0] ? [own_[0], typeof own_[1] === 'string' ? own_[1] : ''] : [b ? b.n : '', null];
  }
  function bowlName() { return S.bowl ? bowlText(S.bowl)[0] : ''; }
  function topWord() { return M.hasMoulded ? 'Top' : 'Benchtop'; }
  function topLabel() {
    var g = byId(LIB.topGroups, S.top);
    if (topKind(S.top) === 'n') return M.hasMoulded ? 'Cabinet only (no top)' : 'Cabinet only (no benchtop)';
    return g.n + (S.colour != null && LIB.tops[S.colour] ? ' - ' + LIB.tops[S.colour].n : '');
  }
  function stdOf(top) { var g = byId(LIB.topGroups, top); return M.std && typeof M.std[top] === 'string' ? M.std[top] : (g ? g.std : ''); }   // the thickness the benchtop comes in ('' where ADP's sources disagree)
  function thickLabel() {
    var t = S.thick === 'std' ? null : byId(M.thick, S.thick), sd = stdOf(S.top);
    return t ? t.n : 'Standard' + (sd ? ' ' + sd : '');
  }
  function basinLabel(withCode) {
    if (S.basin === 'none') return 'No basin';
    var c = combo(), n = c && c.nb > 1 ? c.nb + ' x ' : '';
    var ii = incBasinIndex();
    if (ii > -1) {
      var ib = M.incBasin[ii];
      return n + ib.n + (ib.type ? ', ' + ib.type.toLowerCase() : '') + (withCode && ib.c ? ' (' + ib.c + ')' : '') + ', included';
    }
    var b = M.basins[S.basin];
    var type = byId(LIB.basinTypes, b.g).n.toLowerCase();
    return n + b.fam + (b.col ? ' ' + b.col : '') + ', ' + type + (withCode ? ' (' + b.c + ')' : '');
  }
  function tapLabel() {
    var t = byId(LIB.taps, S.tap), c = combo();
    var s = t.id.charAt(0) === '0' ? 'No tap hole' + (t.pos ? ' - ' + t.pos.toLowerCase() : '') : t.n + (t.pos ? ' - ' + t.pos : '');
    return s + (c && c.nb > 1 ? ' (each basin)' : '');
  }
  function wasteLabel() {
    var w = byCode(M.wastes, S.waste), c = combo();
    return (c && c.nb > 1 ? c.nb + ' x ' : '') + w.n + (w.inc ? ' (included)' : '');
  }
  function powerLabel() {
    if (!S.power) return 'None';
    return byCode(M.power, S.power).n + (S.side ? ', ' + S.side.toLowerCase() + (M.powerAsk ? '' : ' drawer') : '');
  }
  function kitLabel() {
    var c = combo();
    if (c && c.kitInc) return 'Space Saver Plumbing Kit (included)';
    if (M.kit && S.kit) return (c && c.nb > 1 ? c.nb + ' x ' : '') + M.kit.n;
    return '';
  }
  function lines() {                     // everything that goes in the cart: the vanity first, then its add-ons
    var out = [], v = variant(), c = combo();
    if (!v || !c) return out;
    var kind = topKind(S.top), hasTop = kind !== 'n', bench = kind === 'b';
    var props = {};
    if (S.fin != null) props['Cabinet finish'] = LIB.fins[S.fin].n;
    if (frontsOn() && S.front != null && M.fronts.items[S.front]) props['Cabinet fronts'] = M.fronts.items[S.front].n;
    M.picks.forEach(function (p) { if (pickOn(p) && pickVal(p) != null) props[p.prop] = pickLabel(p); });
    if (needsHinge() && S.hinge) props['Door hinge side'] = S.hinge;
    if (!hasTop && c.anyNT) props['Bowl position'] = bowlName();      // the cabinet-only code covers every single-bowl position, so the order has to say which
    if (!hasTop) props[topWord()] = topLabel();
    else if (bench) { if (S.colour != null) { props[topWord()] = topLabel(); props['Benchtop thickness'] = thickLabel(); } }
    else if (stepOn('top')) props[topWord()] = topLabel();            // a moulded top the customer chose (a single fixed top is the product itself)
    if (bench && S.basin != null && stepOn('basin')) props['Basin'] = basinLabel(true);
    if (hasTop && S.tap && stepOn('tap')) props['Tap holes'] = tapLabel();
    if (hasTop && S.waste && (stepOn('waste') || M.wasteAuto)) props['Plug & waste'] = wasteLabel();
    if (S.power) props['In-drawer power point'] = powerLabel();
    if (kitLabel()) props['Plumbing kit'] = kitLabel();
    if (SET.require_ack && S.ack) props['Made to order'] = 'Accepted';
    out.push({ kind: 'vanity', sku: v.sku, id: v.id, title: M.title, sub: v.title === 'Default Title' ? '' : v.title, qty: 1, p: v.price, cp: v.compare || 0, props: props });

    var withName = M.title + ' ' + sizeLabel();
    function addOn(kind, sku, sub, qty, extra) {
      var k = CAT[sku], pr = { 'Added with': withName }, key;
      if (!k) return;
      for (key in (extra || {})) pr[key] = extra[key];
      out.push({ kind: kind, sku: sku, id: k.id, title: k.t, sub: sub || (k.v !== 'Default Title' ? k.v : ''), qty: qty, p: k.p, cp: k.cp || 0, props: pr });
    }
    if (bench && S.colour != null && S.thick !== 'std') {
      var t = byId(M.thick, S.thick);
      if (t && thickAllowed(t)) addOn('thick', t.c, t.n, 1, { 'Thickness': t.mm + 'mm' });
    }
    if (frontsOn() && S.front != null && M.fronts.items[S.front]) addOn('fronts', M.fronts.c, M.fronts.items[S.front].n, 1, { 'Design': M.fronts.items[S.front].n });
    M.picks.forEach(function (p) {       // a choice that costs extra for each one fitted (premium handles)
      var extra = {};
      if (!pickOn(p) || !feeOn(p) || !S.pq[p.id]) return;
      extra[p.prop] = pickLabel(p);
      addOn('fee', p.fee.c, pickLabel(p), S.pq[p.id], extra);
    });
    if (bench && typeof S.basin === 'number' && stepOn('basin')) {
      var b = M.basins[S.basin];
      addOn('basin', b.c, b.col, c.nb, { 'Mounting': byId(LIB.basinTypes, b.g).n });
    }
    if (hasTop && S.waste && stepOn('waste')) {
      var w = byCode(M.wastes, S.waste);
      if (w && !w.inc) addOn('waste', w.c, w.n, c.nb);
    }
    if (S.power) addOn('power', S.power, byCode(M.power, S.power).n, 1, S.side ? { 'Drawer': S.side } : null);
    if (M.kit && S.kit && !c.kitInc) addOn('kit', M.kit.c, '', c.nb);
    M.extras.forEach(function (x) {
      extraChosen(x).forEach(function (it) {
        var pr = {};
        it.ask.forEach(function (q) {
          var a = extraAnswer(x, it, q);
          if (a != null) pr[q.prop || q.id] = q.opts ? String(a) : a + (q.unit || '');
        });
        addOn('extra', it.c, x.single ? it.n : '', x.perBasin ? c.nb : 1, pr);
      });
    });
    return out;
  }
  function fromPrice() {                 // lowest price that still matches the choices made so far
    var best = null;
    function see(v) { if (v && (best == null || v.price < best)) best = v.price; }
    if (S.size != null) {
      (S.bowl ? [byId(BOWLS, S.bowl)] : bowlsFor(S.size)).forEach(function (b) { see(baseVariant(S.size, b.id)); });
    } else {
      M.sizes.forEach(function (sz) { bowlsFor(sz).forEach(function (b) { see(baseVariant(sz, b.id)); }); });
    }
    return best || 0;
  }
  function totals(ls) {
    var t = 0, r = 0;
    ls.forEach(function (l) { t += l.qty * l.p; r += l.qty * (l.cp > l.p ? l.cp : l.p); });
    return { total: t, rrp: r, save: r - t };
  }
  function saveLine(t) {                 // "RRP / You save" under a total: only when the section setting asks for it (1.4.2)
    return SET.show_saving === true && t.save > 0 ? '<p class="bbvb-save">RRP ' + money(t.rrp) + ' \u00b7 You save <b>' + money(t.save) + '</b></p>' : '';
  }
  function buildId() {
    return 'VB-' + (Date.now().toString(36) + Math.random().toString(36).slice(2, 6)).slice(-8).toUpperCase();
  }
  function payload(mode) {               // the body for /cart/add.js. mode: 'nested' | 'flat' (default: the setting)
    var ls = lines();
    if (!ls.length) return { items: [] };
    var nested = mode ? mode === 'nested' : SET.nest !== false;
    if (!S.build) S.build = buildId();
    var parent = ls[0].id;
    var items = ls.map(function (l, i) {
      var pr = {}, k;
      for (k in l.props) pr[k] = l.props[k];
      pr._build = S.build;
      var it = { id: l.id, quantity: l.qty, properties: pr };
      if (nested && i > 0) it.parent_id = parent;
      return it;
    });
    if (!nested) items.reverse();        // Shopify lists the newest line first, so the vanity goes in last
    return { items: items };
  }

  /* ---------- drawings ---------- */
  function bowlIcon(xs) {
    var s = '<svg viewBox="0 0 84 60" aria-hidden="true"><rect x="3" y="12" width="78" height="38" rx="3" fill="#fbf4ec" stroke="' + INK + '" stroke-width="1.5"/>';
    xs.forEach(function (x) {
      s += '<ellipse cx="' + (3 + 78 * x).toFixed(1) + '" cy="32" rx="' + (xs.length > 1 ? 10 : 12) + '" ry="10" fill="#fff" stroke="' + INK + '" stroke-width="1.5"/>';
    });
    return s + '</svg>';
  }
  function hingeIcon(left) {             // a door seen from the front, hinges on one side
    var hx = left ? 22 : 62, knob = left ? 56 : 28;
    return '<svg viewBox="0 0 84 60" aria-hidden="true"><rect x="20" y="6" width="44" height="48" rx="2" fill="#fbf4ec" stroke="' + INK + '" stroke-width="1.5"/>' +
      '<rect x="' + (hx - 2) + '" y="13" width="4" height="8" fill="' + INK + '"/><rect x="' + (hx - 2) + '" y="39" width="4" height="8" fill="' + INK + '"/>' +
      '<circle cx="' + knob + '" cy="30" r="2.6" fill="#fff" stroke="' + INK + '" stroke-width="1.5"/></svg>';
  }
  function sideIcon(left) {              // a cabinet seen from the front, one half marked
    var x = left ? 8 : 42;
    return '<svg viewBox="0 0 84 60" aria-hidden="true"><rect x="8" y="10" width="68" height="40" rx="2" fill="#fbf4ec" stroke="' + INK + '" stroke-width="1.5"/>' +
      '<rect x="' + x + '" y="10" width="34" height="40" fill="' + INK + '" fill-opacity=".22"/>' +
      '<path d="M42 10v40M' + (x + 9) + ' 23h16M' + (x + 9) + ' 37h16" fill="none" stroke="' + INK + '" stroke-width="1.5"/></svg>';
  }
  function tapDots(id, cx, cy, rx, ry, r) {
    var y = cy - ry - r - 4, s = '';
    function dot(x, yy, hollow) {
      return '<circle cx="' + x.toFixed(1) + '" cy="' + yy.toFixed(1) + '" r="' + r + '" fill="' + (hollow ? '#fff' : INK) + '" stroke="' + INK + '" stroke-width="1.5"/>';
    }
    if (id === '1-12' || id === '1') s += dot(cx, y);
    else if (id === '1-10') s += dot(cx - rx * 0.8, y + ry * 0.28);
    else if (id === '1-2') s += dot(cx + rx * 0.8, y + ry * 0.28);
    else if (id === '1-9') s += dot(cx - rx - r - 4, cy);
    else if (id === '1-3') s += dot(cx + rx + r + 4, cy);
    else if (id === '3') s += dot(cx - r * 4.2, y) + dot(cx, y) + dot(cx + r * 4.2, y);
    else if (id === '0-basin') s += dot(cx, cy - ry + r + 3, true);
    return s;
  }
  function tapIcon(id) {
    var s = '<svg viewBox="0 0 84 60" aria-hidden="true">' +
      '<rect x="3" y="3" width="78" height="5" fill="' + (id === '0-wall' ? INK : '#d9cfc0') + '"/>' +
      '<rect x="3" y="8" width="78" height="49" fill="#fbf4ec" stroke="' + INK + '" stroke-width="1.5"/>' +
      '<ellipse cx="42" cy="38" rx="20" ry="13" fill="#fff" stroke="' + INK + '" stroke-width="1.5"/>';
    if (id === '0-wall') s += '<rect x="34" y="1" width="4" height="9" fill="' + INK + '"/><rect x="46" y="1" width="4" height="9" fill="' + INK + '"/>';
    if (id === '0-own') s += '<circle cx="42" cy="17" r="3.2" fill="none" stroke="' + INK + '" stroke-width="1.5" stroke-dasharray="2 2"/>';
    return s + tapDots(id, 42, 38, 20, 13, 3.2) + '</svg>';
  }
  function plan() {                      // top view of the benchtop, drawn from the current choices
    var c = combo();
    if (!c) return '';
    var bowl = byId(BOWLS, S.bowl);
    var noTop = !!S.top && topKind(S.top) === 'n', moulded = !!S.top && topKind(S.top) === 'm';
    var x0 = 30, w = 260, y0 = 20, h = !c.d || c.d >= 450 ? 80 : 64;
    var fill = !noTop && S.colour != null && LIB.tops[S.colour] && LIB.tops[S.colour].bg ? esc(LIB.tops[S.colour].bg) : '#fff';
    var font = ' font-family="Montserrat,Arial,sans-serif"';
    var s = '<svg viewBox="0 -8 320 ' + (y0 + h + 42) + '" role="img" aria-label="Top view of your benchtop">' +
      '<rect x="10" y="6" width="300" height="8" fill="' + (S.tap === '0-wall' && !noTop ? INK : '#d9cfc0') + '"/>' +
      '<text x="310" y="2" text-anchor="end" font-size="8" fill="#5b6773" letter-spacing="1"' + font + '>WALL</text>' +
      '<rect x="' + x0 + '" y="' + y0 + '" width="' + w + '" height="' + h + '" rx="3" fill="' + fill + '" stroke="' + INK + '" stroke-width="1.5"' + (noTop ? ' stroke-dasharray="5 4"' : '') + '/>';
    if (noTop) {
      s += '<text x="160" y="' + (y0 + h / 2 + 4) + '" text-anchor="middle" font-size="12" fill="#5b6773"' + font + '>Cabinet only, no ' + (M.hasMoulded ? 'top' : 'benchtop') + '</text>';
    } else {
      var picked = moulded || (S.basin != null && S.basin !== 'none');
      bowl.xs.forEach(function (x) {
        var cx = x0 + w * x, cy = y0 + h / 2 + 6, rx = bowl.xs.length > 1 ? 30 : 34, ry = h * 0.3;
        if (moulded || S.basin !== 'none') s += '<ellipse cx="' + cx.toFixed(1) + '" cy="' + cy + '" rx="' + rx + '" ry="' + ry.toFixed(1) + '" fill="#fff" fill-opacity="' + (picked ? 1 : 0.6) + '" stroke="' + INK + '" stroke-width="1.5"' + (picked ? '' : ' stroke-dasharray="4 3"') + '/>';
        if (S.tap === '0-wall') s += '<rect x="' + (cx - 8) + '" y="3" width="4" height="13" fill="' + INK + '"/><rect x="' + (cx + 4) + '" y="3" width="4" height="13" fill="' + INK + '"/>';
        if (S.tap && stepOn('tap')) s += tapDots(S.tap, cx, cy, rx, ry, 3.5);
      });
    }
    s += '<text x="160" y="' + (y0 + h + 18) + '" text-anchor="middle" font-size="11" fill="' + INK + '"' + font + '>' + (c.w ? (+c.w) + ' wide' + (c.d ? ' \u00d7 ' + (+c.d) + ' deep' : '') + ' (mm)' : '') + '</text>' +
      '<text x="160" y="' + (y0 + h + 30) + '" text-anchor="middle" font-size="8" fill="#5b6773" letter-spacing="1"' + font + '>FRONT</text></svg>';
    return s;
  }
  var BASIN_GLYPH = '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><ellipse cx="24" cy="26" rx="18" ry="11"/><ellipse cx="24" cy="26" rx="11" ry="6"/><circle cx="24" cy="26" r="1.5"/></svg>';
  var TICK = '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="24" cy="24" r="20"/><path d="M14 24.5l7 7L34.5 17"/></svg>';

  /* ---------- building blocks ---------- */
  function sec(title, note, body) {
    return '<section class="bbvb-sec"><h3 class="bbvb-sec__h">' + esc(title) + (note ? ' <small>' + esc(note) + '</small>' : '') + '</h3>' + body + '</section>';
  }
  function swatch(item, on, action, value) {
    return '<button type="button" class="bbvb-sw' + (on ? ' is-on' : '') + '" data-a="' + action + '" data-v="' + (+value) + '" data-k="' + action + (+value) + '" aria-pressed="' + on + '">' +
      '<span class="bbvb-sw__img" style="background:' + esc(item.bg || '#eee') + '">' + img(sized(file(item.f), 240, 240), '') + '</span>' +
      '<span class="bbvb-sw__n">' + esc(item.n) + '</span></button>';
  }
  function priceTag(cents, compare) {
    return money(cents) + (compare && compare > cents ? ' <s>' + money(compare) + '</s>' : '');
  }
  function heroSrc() {                   // the picture for the current size and bowl position
    var c = combo(), v = null;
    if (c) v = (S.top && variantFor(S.size, S.bowl, S.top)) || baseVariant(S.size, S.bowl);
    else if (S.size != null) { var bs = bowlsFor(S.size); v = bs.length ? baseVariant(S.size, bs[0].id) : null; }
    else { var b0 = bowlsFor(M.sizes[0]); v = b0.length ? baseVariant(M.sizes[0], b0[0].id) : null; }
    return (v && v.image) || CFG.product.image || '';
  }

  /* ---------- steps ---------- */
  function stepSize() {
    var h = '<div class="bbvb-grid bbvb-grid--chips' + (M.sizeL ? ' bbvb-grid--sizes' : '') + '">' + M.sizes.map(function (sz) {
      var from = null;
      bowlsFor(sz).forEach(function (b) { var v = baseVariant(sz, b.id); if (v && (from == null || v.price < from)) from = v.price; });
      var on = S.size === sz;
      return '<button type="button" class="bbvb-opt bbvb-size' + (M.sizeL ? ' bbvb-size--txt' : '') + (on ? ' is-on' : '') + '" data-a="size" data-v="' + (+sz) + '" data-k="size' + (+sz) + '" aria-pressed="' + on + '">' +
        '<span class="bbvb-opt__t">' + (M.sizeL ? esc(sizeText(sz)) : (+sz) + '<small>mm</small>') + '</span>' +
        '<span class="bbvb-opt__d"><i>from</i> ' + money(from) + '</span></button>';
    }).join('') + '</div>';
    var out = M.sizes.length > 1 ? sec(M.sizeHead || 'Width', '', h) : '';      // one size: nothing to pick, only where the basin sits
    if (S.size != null) {
      var bs = bowlsFor(S.size), any = M.combos[S.size + '|' + bs[0].id];
      var dims = any.w && any.h && any.d ? (+any.w) + ' wide \u00d7 ' + (+any.h) + ' high \u00d7 ' + (+any.d) + ' deep (mm)' : '';
      var cards = bs.map(function (b) {
        var c = M.combos[S.size + '|' + b.id];
        var v = (S.top && variantFor(S.size, b.id, S.top)) || baseVariant(S.size, b.id);
        var on = S.bowl === b.id, bt = bowlText(b.id);
        return '<button type="button" class="bbvb-opt bbvb-opt--row' + (on ? ' is-on' : '') + '" data-a="bowl" data-v="' + b.id + '" data-k="bowl' + b.id + '" aria-pressed="' + on + '">' +
          '<span class="bbvb-opt__icon">' + bowlIcon(b.xs) + '</span><span class="bbvb-opt__txt">' +
          '<span class="bbvb-opt__t">' + esc(bt[0]) + '</span>' +
          '<span class="bbvb-opt__d">' + (bt[1] != null ? esc(bt[1]) : (c.nb > 1 ? 'Two basins' : 'One basin')) + '</span>' +
          '<span class="bbvb-opt__p">' + priceTag(v.price, v.compare) + '</span></span></button>';
      }).join('');
      if (!M.oneBowl) out += sec(M.bowlHead || 'Bowl position', dims, '<div class="bbvb-grid bbvb-grid--cards">' + cards + '</div>');
      else if (dims) out += '<p class="bbvb-help">' + dims + '</p>';
      if (needsHinge()) {
        var hs = M.hinge.opts.map(function (o, i) {
          var on = S.hinge === o;
          return '<button type="button" class="bbvb-opt bbvb-opt--row' + (on ? ' is-on' : '') + '" data-a="hinge" data-v="' + i + '" data-k="hinge' + i + '" aria-pressed="' + on + '">' +
            '<span class="bbvb-opt__icon">' + hingeIcon(/left/i.test(o)) + '</span><span class="bbvb-opt__txt"><span class="bbvb-opt__t">' + esc(o) + '</span></span></button>';
        }).join('');
        out += sec('Door hinge side', 'As you face the vanity', '<div class="bbvb-grid bbvb-grid--cards">' + hs + '</div>');
      }
    }
    return out;
  }

  function stepTop() {
    var base = baseVariant(S.size, S.bowl);
    var mats = topsAvailable().map(function (g) {
      var v = variantFor(S.size, S.bowl, g.id), delta = v.price - base.price, on = S.top === g.id;
      return '<button type="button" class="bbvb-opt' + (on ? ' is-on' : '') + '" data-a="top" data-v="' + esc(g.id) + '" data-k="top' + esc(g.id) + '" aria-pressed="' + on + '">' +
        '<span class="bbvb-opt__t">' + esc(g.n) + '</span>' +
        '<span class="bbvb-opt__d">' + esc(g.d) + (stdOf(g.id) ? ' \u00b7 ' + esc(stdOf(g.id)) : '') + '</span>' +
        (delta === 0 ? '<span class="bbvb-opt__p is-inc">Included</span>' : '<span class="bbvb-opt__p">' + (delta > 0 ? '+' : '') + money(delta) + '</span>') +
        '</button>';
    }).join('');
    var out = sec(M.hasMoulded ? 'Top' : 'Material', '', '<div class="bbvb-grid bbvb-grid--cards">' + mats + '</div>');
    if (S.top && topKind(S.top) === 'n') {
      out += '<div class="bbvb-notice">Cabinet only comes without a ' + (M.hasMoulded ? 'top' : 'benchtop') + ', so the basin, tap hole and plug & waste steps are skipped.</div>';
    } else if (S.top) {
      var g = byId(LIB.topGroups, S.top), sw = '';
      topColours(S.top).forEach(function (i) { sw += swatch(LIB.tops[i], S.colour === i, 'colour', i); });
      if (sw) out += sec(g.n + ' colour', '', '<div class="bbvb-grid bbvb-grid--sw">' + sw + '</div>');
      if (M.topNote && typeof M.topNote[S.top] === 'string' && M.topNote[S.top]) out += '<div class="bbvb-notice">' + esc(M.topNote[S.top]) + '</div>';
    }
    return out;
  }

  function stepThick() {
    var g = byId(LIB.topGroups, S.top);
    var std = '<button type="button" class="bbvb-opt' + (S.thick === 'std' ? ' is-on' : '') + '" data-a="thick" data-v="std" data-k="thickstd" aria-pressed="' + (S.thick === 'std') + '">' +
      '<span class="bbvb-opt__thumb">' + esc(stdOf(g.id)) + '</span><span class="bbvb-opt__t">' + esc('Standard ' + stdOf(g.id)) + '</span><span class="bbvb-opt__p is-inc">Included</span></button>';
    var th = M.thick.map(function (t) {
      var ok = thickAllowed(t), on = S.thick === t.id;
      var only = !ok ? LIB.topGroups.filter(function (x) { return t.tops.indexOf(x.id) > -1; }).map(function (x) { return x.n; }).join(' or ') + ' only' : '';
      return '<button type="button" class="bbvb-opt' + (on ? ' is-on' : '') + '" data-a="thick" data-v="' + esc(t.id) + '" data-k="thick' + esc(t.id) + '" aria-pressed="' + on + '"' + (ok ? '' : ' disabled') + '>' +
        '<span class="bbvb-opt__thumb bbvb-opt__thumb--cover">' + (t.img ? img(sized(t.img, 420), '') : esc(t.mm + 'mm')) + '</span>' +
        '<span class="bbvb-opt__t">' + esc(t.n) + '</span>' +
        (only ? '<span class="bbvb-opt__d">' + esc(only) + '</span>' : '') +
        '<span class="bbvb-opt__p">+' + priceTag(t.k.p, t.k.cp) + '</span></button>';
    }).join('');
    return '<div class="bbvb-sec"><div class="bbvb-grid bbvb-grid--thumb">' + std + th + '</div></div>';
  }

  function stepFin() {
    var list = finsFor();
    var out = LIB.finGroups.map(function (g) {
      var sw = '', n = 0;
      list.forEach(function (i) { var f = LIB.fins[i]; if (f.g === g.id) { sw += swatch(f, S.fin === i, 'fin', i); n++; } });
      var canFront = n && M.fronts && M.fronts.fg.indexOf(g.id) > -1;
      var notAll = canFront && M.fronts.w && list.some(function (i) { return LIB.fins[i].g === g.id && !!LIB.fins[i].nf; });
      return n ? sec(g.n, n + (n === 1 ? ' finish' : ' finishes') + (canFront ? ' \u00b7 classic cabinet fronts available' + (notAll ? ', ' + M.fronts.w.toLowerCase() + ' only' : '') : ''), '<div class="bbvb-grid bbvb-grid--sw">' + sw + '</div>') : '';
    }).join('') + '<p class="bbvb-help">Screen colours are a guide only. The picture of the vanity doesn\u2019t change with the finish you pick.</p>';
    return out;
  }

  function stepFront() {                 // the finish chosen can have classic fronts: flat is standard, a design is one charge
    var k = M.fronts.k;
    var cards = '<button type="button" class="bbvb-opt' + (S.front == null ? ' is-on' : '') + '" data-a="front" data-v="std" data-k="frontstd" aria-pressed="' + (S.front == null) + '">' +
      '<span class="bbvb-opt__thumb">Flat</span><span class="bbvb-opt__t">Standard flat fronts</span><span class="bbvb-opt__p is-inc">Included</span></button>';
    cards += M.fronts.items.map(function (it, i) {
      var on = S.front === i;
      return '<button type="button" class="bbvb-opt' + (on ? ' is-on' : '') + '" data-a="front" data-v="' + i + '" data-k="front' + i + '" aria-pressed="' + on + '">' +
        '<span class="bbvb-opt__thumb bbvb-opt__thumb--photo">' + (it.img ? img(sized(it.img, 320), '') : '') + '</span>' +
        '<span class="bbvb-opt__t">' + esc(it.n) + '</span><span class="bbvb-opt__p">+' + priceTag(k.p, k.cp) + '</span></button>';
    }).join('');
    return '<div class="bbvb-sec"><div class="bbvb-grid bbvb-grid--thumb">' + cards + '</div></div>';
  }

  function stepBasin() {
    var c = combo();
    if (M.incBasin) {
      var inc = M.incBasin.map(function (b, i) {
        var on = S.basin === 'i' + i, off = M.vary === 'basin' && !varyHas(i);
        return '<div class="bbvb-basin bbvb-basin--inc' + (on ? ' is-on' : '') + '"><button type="button" class="bbvb-basin__pick" data-a="basin" data-v="i' + i + '" data-k="inc' + i + '" aria-pressed="' + on + '"' + (off ? ' disabled' : '') + '>' +
          '<span class="bbvb-basin__img">' + (b.img ? img(sized(b.img, 480), '') : BASIN_GLYPH) + '</span>' +
          '<span class="bbvb-basin__body"><span class="bbvb-basin__t">' + esc(b.n) + '</span>' +
          '<span class="bbvb-basin__d">' + esc(b.type) + '</span>' +
          '<span class="bbvb-basin__p is-inc">Included</span></span></button></div>';
      }).join('');
      return '<div class="bbvb-sec"><div class="bbvb-grid bbvb-grid--basin">' + inc + '</div></div>';
    }
    var idx = allowedBasins(), groups = [], seen = {};
    idx.forEach(function (i) {
      var b = M.basins[i];
      if (!seen[b.key]) { seen[b.key] = { g: b.g, key: b.key, fam: b.fam, items: [] }; groups.push(seen[b.key]); }
      seen[b.key].items.push(i);
    });
    var each = c.nb > 1 ? ' each' : '';
    var chips = '<button type="button" class="bbvb-chip' + (S.bf === 'all' ? ' is-on' : '') + '" data-a="bf" data-v="all" data-k="bfall" aria-pressed="' + (S.bf === 'all') + '">All<span>' + groups.length + '</span></button>';
    LIB.basinTypes.forEach(function (t) {
      var n = groups.filter(function (g) { return g.g === t.id; }).length;
      if (n) chips += '<button type="button" class="bbvb-chip' + (S.bf === t.id ? ' is-on' : '') + '" data-a="bf" data-v="' + esc(t.id) + '" data-k="bf' + esc(t.id) + '" aria-pressed="' + (S.bf === t.id) + '">' + esc(t.n) + '<span>' + n + '</span></button>';
    });
    var none = S.basin === 'none';
    var cards = '<div class="bbvb-basin bbvb-basin--none' + (none ? ' is-on' : '') + '">' +
      '<button type="button" class="bbvb-basin__pick" data-a="basin" data-v="none" data-k="basinnone" aria-pressed="' + none + '">' +
      '<span class="bbvb-basin__img">' + BASIN_GLYPH + '</span><span class="bbvb-basin__body">' +
      '<span class="bbvb-basin__t">No basin</span><span class="bbvb-basin__d">Buy the vanity on its own. Basins are sold separately.</span>' +
      '</span></button></div>';
    groups.forEach(function (g) {
      if (S.bf !== 'all' && S.bf !== g.g) return;
      var type = byId(LIB.basinTypes, g.g).n;
      var avail = g.items.filter(function (i) { return M.basins[i].ok && !M.basins[i].oos; });
      var sel = typeof S.basin === 'number' && g.items.indexOf(S.basin) > -1 ? S.basin : null;
      var def = null, min = null, max = null;       // the default colour is the cheapest one that can be bought
      avail.forEach(function (i) {
        var p = M.basins[i].k.p;
        if (min == null || p < min) { min = p; def = i; }
        if (max == null || p > max) max = p;
      });
      var shown = M.basins[sel != null ? sel : (def != null ? def : g.items[0])].k;
      var k = sel != null ? M.basins[sel].k : null;
      var price = k ? priceTag(k.p, k.cp) + each : (avail.length ? (min !== max ? 'from ' : '') + money(min) + each : 'Out of stock');
      var foot = '';
      if (sel != null && g.items.length > 1) {
        foot = '<div class="bbvb-basin__cols" role="group" aria-label="' + esc(g.fam) + ' colour"><span>Pick a colour</span>' + g.items.map(function (i) {
          var b = M.basins[i], off = !b.ok || b.oos, on = sel === i;
          return '<button type="button" class="bbvb-col' + (on ? ' is-on' : '') + '" data-a="bcol" data-v="' + i + '" data-k="col' + i + '" aria-pressed="' + on + '"' + (off ? ' disabled' : '') + '>' + esc(b.col || b.c) + (off ? ' (out of stock)' : '') + '</button>';
        }).join('') + '</div>';
      } else {
        foot = '<span class="bbvb-basin__n">' + (g.items.length > 1 ? g.items.length + ' colours' : esc(M.basins[g.items[0]].col)) + '</span>';
      }
      cards += '<div class="bbvb-basin' + (sel != null ? ' is-on' : '') + '">' +
        '<button type="button" class="bbvb-basin__pick" data-a="basin" data-v="' + (sel != null ? sel : (def == null ? '' : def)) + '" data-k="fam' + esc(g.key) + '"' + (def == null && sel == null ? ' disabled' : '') + ' aria-pressed="' + (sel != null) + '">' +
        '<span class="bbvb-basin__img">' + (shown.img ? img(sized(shown.img, 480), '') : BASIN_GLYPH) + '</span>' +
        '<span class="bbvb-basin__body"><span class="bbvb-basin__t">' + esc(g.fam) + '</span>' +
        '<span class="bbvb-basin__d">' + esc(type) + (shown.dims ? ' \u00b7 ' + esc(shown.dims) : '') + '</span>' +
        '<span class="bbvb-basin__p">' + price + '</span></span></button>' +
        '<div class="bbvb-basin__foot">' + foot + '</div></div>';
    });
    return (groups.length ? '<div class="bbvb-sec"><div class="bbvb-chips" role="group" aria-label="Basin type">' + chips + '</div></div>' : '') +
      '<div class="bbvb-sec"><div class="bbvb-grid bbvb-grid--basin">' + cards + '</div></div>';
  }

  function stepTap() {
    var moulded = !!S.top && topKind(S.top) === 'm';
    var cards = tapsFor().filter(function (t) { return !(t.id === '0-basin' && S.basin === 'none'); }).map(function (t) {
      var on = S.tap === t.id, d = moulded ? String(t.d || '').replace(/\bbenchtop\b/g, 'top') : t.d;      // a moulded top is not a benchtop
      return '<button type="button" class="bbvb-opt bbvb-opt--row' + (on ? ' is-on' : '') + '" data-a="tap" data-v="' + esc(t.id) + '" data-k="tap' + esc(t.id) + '" aria-pressed="' + on + '">' +
        '<span class="bbvb-opt__icon">' + tapIcon(t.id) + '</span><span class="bbvb-opt__txt">' +
        '<span class="bbvb-opt__t">' + esc(t.n + (t.pos ? ' \u00b7 ' + t.pos : '')) + '</span>' +
        '<span class="bbvb-opt__d">' + esc(d) + '</span></span></button>';
    }).join('');
    var tied = M.tapBowl && S.bowl && Array.isArray(M.tapBowl[S.bowl]) && M.tapNote;
    return '<div class="bbvb-sec"><div class="bbvb-grid bbvb-grid--wide">' + cards + '</div></div>' + (tied ? '<p class="bbvb-help">' + esc(M.tapNote) + '</p>' : '') +
      (M.tapHelp ? '<p class="bbvb-help">' + esc(M.tapHelp) + '</p>' : '');
  }

  function stepWaste() {
    var c = combo();
    var cards = M.wastes.map(function (w) {
      var on = S.waste === w.c, k = w.k;
      return '<button type="button" class="bbvb-opt' + (on ? ' is-on' : '') + '" data-a="waste" data-v="' + esc(w.c) + '" data-k="waste' + esc(w.c) + '" aria-pressed="' + on + '">' +
        '<span class="bbvb-opt__thumb bbvb-opt__thumb--photo">' + img(sized(w.img, 320), '') + '</span>' +
        '<span class="bbvb-opt__t">' + esc(w.n) + '</span>' +
        (w.inc ? '<span class="bbvb-opt__p is-inc">Included</span>' : '<span class="bbvb-opt__p">+' + priceTag(k.p * c.nb, (k.cp || 0) * c.nb) + '</span>') +
        (c.nb > 1 && !w.inc ? '<span class="bbvb-opt__d">' + c.nb + ' at ' + money(k.p) + ' each</span>' : '') +
        '</button>';
    }).join('');
    return '<div class="bbvb-sec"><div class="bbvb-grid bbvb-grid--thumb">' + cards + '</div></div>';
  }

  function stepPower() {
    var c = combo();
    var cards = '<button type="button" class="bbvb-opt' + (!S.power ? ' is-on' : '') + '" data-a="power" data-v="" data-k="power0" aria-pressed="' + !S.power + '">' +
      '<span class="bbvb-opt__thumb">None</span><span class="bbvb-opt__t">No power point</span></button>';
    cards += M.power.map(function (p) {
      var on = S.power === p.c;
      return '<button type="button" class="bbvb-opt' + (on ? ' is-on' : '') + '" data-a="power" data-v="' + esc(p.c) + '" data-k="power' + esc(p.c) + '" aria-pressed="' + on + '">' +
        '<span class="bbvb-opt__thumb bbvb-opt__thumb--photo">' + img(sized(p.img, 320), '') + '</span>' +
        '<span class="bbvb-opt__t">' + esc(p.n) + '</span><span class="bbvb-opt__p">+' + priceTag(p.k.p, p.k.cp) + '</span></button>';
    }).join('');
    var out = '<div class="bbvb-sec"><div class="bbvb-grid bbvb-grid--thumb">' + cards + '</div></div>';
    if (needsSide()) {
      var sides = sideOpts().map(function (s) {
        var on = S.side === s;
        return '<button type="button" class="bbvb-opt bbvb-opt--center' + (on ? ' is-on' : '') + '" data-a="side" data-v="' + esc(s) + '" data-k="side' + esc(s) + '" aria-pressed="' + on + '"><span class="bbvb-opt__t">' + esc(s + (M.powerAsk ? '' : ' drawer')) + '</span></button>';
      }).join('');
      out += sec('Which drawer?', 'As you face the vanity', '<div class="bbvb-grid bbvb-grid--pair">' + sides + '</div>');
    }
    return out;
  }

  function stepKit() {
    var c = combo(), k = M.kit.k;
    var kc = '<button type="button" class="bbvb-opt' + (!S.kit ? ' is-on' : '') + '" data-a="kit" data-v="" data-k="kit0" aria-pressed="' + !S.kit + '">' +
      '<span class="bbvb-opt__thumb">None</span><span class="bbvb-opt__t">No plumbing kit</span></button>' +
      '<button type="button" class="bbvb-opt' + (S.kit ? ' is-on' : '') + '" data-a="kit" data-v="1" data-k="kit1" aria-pressed="' + !!S.kit + '">' +
      '<span class="bbvb-opt__thumb bbvb-opt__thumb--photo">' + img(sized(k.img, 320), '') + '</span>' +
      '<span class="bbvb-opt__t">' + esc(M.kit.n) + '</span><span class="bbvb-opt__p">+' + priceTag(k.p * c.nb, (k.cp || 0) * c.nb) + '</span></button>';
    return '<div class="bbvb-sec"><div class="bbvb-grid bbvb-grid--thumb">' + kc + '</div></div>';
  }

  function plural(n, word) { return n + ' ' + word + (n === 1 ? '' : (/(s|sh|ch|x)$/.test(word) ? 'es' : 's')); }
  function stepPick(p) {                 // a no-charge choice: plain options, or a library of pictures grouped by style
    var val = pickVal(p), cards;
    if (p.opts) {
      cards = p.opts.map(function (o, i) {
        var on = val === i, lr = /\bleft\b/i.test(o) ? 1 : (/\bright\b/i.test(o) ? 2 : 0), off = M.vary === p.id && !varyHas(i);
        return '<button type="button" class="bbvb-opt bbvb-opt--row' + (on ? ' is-on' : '') + '" data-a="pick" data-v="' + p.id + '|' + i + '" data-k="pk' + p.id + i + '" aria-pressed="' + on + '"' + (off ? ' disabled' : '') + '>' +
          (lr ? '<span class="bbvb-opt__icon">' + (p.icon === 'hinge' ? hingeIcon(lr === 1) : sideIcon(lr === 1)) + '</span>' : '') + '<span class="bbvb-opt__txt"><span class="bbvb-opt__t">' + esc(o) + '</span>' +
          (p.std === i ? '<span class="bbvb-opt__d">Standard</span>' : '') + '</span></button>';
      }).join('');
      return sec(p.l, p.note, '<div class="bbvb-grid bbvb-grid--cards">' + cards + '</div>');
    }
    var groups = [], seen = Object.create(null);
    p.items.forEach(function (i) {
      var st = p.list[i].s;
      if (!seen[st]) { seen[st] = { s: st, items: [] }; groups.push(seen[st]); }
      seen[st].items.push(i);
    });
    cards = groups.map(function (g, gi) {
      var sel = val != null && g.items.indexOf(val) > -1 ? val : null, first = g.items[0];
      g.items.some(function (i) { if (p.list[i].cv) { first = i; return true; } return false; });   // the finish a style is shown with, and starts on
      var shown = p.list[sel != null ? sel : first], many = g.items.length > 1, foot;
      var pic = shown.f || (p.list[first] && p.list[first].f) || '';      // a finish with no picture of its own shows the style's
      var costs = p.fee && g.items.some(function (i) { return !!p.list[i].pr; });
      if (sel != null && many) {
        foot = '<div class="bbvb-basin__cols" role="group" aria-label="' + esc(g.s + ' ' + p.unit) + '"><span>Pick a ' + esc(p.unit) + '</span>' + g.items.map(function (i) {
          var on = sel === i;
          return '<button type="button" class="bbvb-col' + (on ? ' is-on' : '') + '" data-a="pcol" data-v="' + p.id + '|' + i + '" data-k="pc' + p.id + i + '" aria-pressed="' + on + '">' + esc(p.list[i].n || p.list[i].s) + '</button>';
        }).join('') + '</div>';
      } else {
        foot = '<span class="bbvb-basin__n">' + (many ? esc(plural(g.items.length, p.unit)) : esc(shown.n)) + '</span>';
      }
      return '<div class="bbvb-basin bbvb-basin--pick' + (sel != null ? ' is-on' : '') + (sel != null && many ? ' is-wide' : '') + '">' +
        '<button type="button" class="bbvb-basin__pick" data-a="pick" data-v="' + p.id + '|' + (sel != null ? sel : first) + '" data-k="pk' + p.id + 'g' + gi + '" aria-pressed="' + (sel != null) + '">' +
        '<span class="bbvb-basin__img">' + (pic ? img(sized(file(pic), 480), '') : '') + '</span>' +
        '<span class="bbvb-basin__body"><span class="bbvb-basin__t">' + esc(g.s) + '</span>' +
        (p.fee ? (costs ? '<span class="bbvb-basin__p">+' + priceTag(p.fee.k.p, p.fee.k.cp) + ' ' + esc(p.fee.each) + '</span>' : '<span class="bbvb-basin__p is-inc">Included</span>') : '') +
        '</span></button>' +
        '<div class="bbvb-basin__foot">' + foot + '</div></div>';
    }).join('');
    var out = '<div class="bbvb-sec"><div class="bbvb-grid bbvb-grid--basin bbvb-grid--dense">' + cards + '</div></div>';
    if (feeOn(p)) {                      // the chosen one is charged for each one fitted: ask how many
      var q = S.pq[p.id], o = '<option value="' + esc(p.id + '|') + '"' + (q == null ? ' selected' : '') + '>Choose\u2026</option>', n, prob = problem(p.id);
      for (n = p.fee.min; n <= p.fee.max; n += 1) o += '<option value="' + esc(p.id + '|' + n) + '"' + (q === n ? ' selected' : '') + '>' + n + '</option>';
      out += sec(p.fee.l, p.fee.note, '<label class="bbvb-ask"><select data-a="pq" data-k="pq' + esc(p.id) + '" aria-label="' + esc(p.fee.l) + '">' + o + '</select></label>') +
        '<div class="bbvb-acc__cta"><button type="button" class="bbvb-btn bbvb-btn--primary" data-a="next" data-k="pqnext' + esc(p.id) + '"' + (prob ? ' disabled' : '') + '>Continue</button>' +
        (prob ? '<span class="bbvb-acc__why">' + esc(prob) + ' to continue</span>' : '') + '</div>';
    }
    return out;
  }

  function stepExtra(x) {                // priced extras: any number of them, each with the questions it needs answered
    var chosen = extraChosen(x), e = S.ex[x.id] || {};
    var cards = '<button type="button" class="bbvb-opt' + (!chosen.length ? ' is-on' : '') + '" data-a="exnone" data-v="' + x.id + '" data-k="ex' + x.id + '0" aria-pressed="' + !chosen.length + '">' +
      '<span class="bbvb-opt__thumb">None</span><span class="bbvb-opt__t">' + esc(x.none) + '</span></button>';
    var c = combo(), times = x.perBasin && c ? c.nb : 1;
    cards += x.items.map(function (it) {
      var on = !!e[it.c];
      return '<button type="button" class="bbvb-opt' + (on ? ' is-on' : '') + '" data-a="ex" data-v="' + esc(x.id + '|' + it.c) + '" data-k="ex' + esc(x.id + it.c) + '" aria-pressed="' + on + '">' +
        '<span class="bbvb-opt__thumb bbvb-opt__thumb--photo">' + (it.img ? img(sized(it.img, 320), '') : '') + '</span>' +
        '<span class="bbvb-opt__t">' + esc(it.n) + '</span>' + (it.d ? '<span class="bbvb-opt__d">' + esc(it.d) + '</span>' : '') +
        '<span class="bbvb-opt__p">+' + priceTag(it.k.p * times, (it.k.cp || 0) * times) + '</span>' +
        (times > 1 ? '<span class="bbvb-opt__d">' + times + ' at ' + money(it.k.p) + ' each</span>' : '') + '</button>';
    }).join('');
    var out = '<div class="bbvb-sec"><div class="bbvb-grid bbvb-grid--thumb">' + cards + '</div></div>';
    chosen.forEach(function (it) {
      it.ask.forEach(function (q) {
        var a = extraAnswer(x, it, q), key = x.id + '|' + it.c + '|' + q.id, body, o, n;
        if (q.opts) {
          body = '<div class="bbvb-grid bbvb-grid--pair">' + q.opts.map(function (opt) {
            var on = a === opt;
            return '<button type="button" class="bbvb-opt bbvb-opt--center' + (on ? ' is-on' : '') + '" data-a="exq" data-v="' + esc(key + '|' + opt) + '" data-k="exq' + esc(key + opt) + '" aria-pressed="' + on + '"><span class="bbvb-opt__t">' + esc(opt) + '</span></button>';
          }).join('') + '</div>';
        } else {
          o = '<option value="' + esc(key + '|') + '"' + (a == null ? ' selected' : '') + '>Choose\u2026</option>';
          for (n = q.min; n <= q.max; n += 1) o += '<option value="' + esc(key + '|' + n) + '"' + (a === n ? ' selected' : '') + '>' + n + esc(q.unit || '') + '</option>';
          body = '<label class="bbvb-ask"><select data-a="exq" data-k="exq' + esc(key) + '" aria-label="' + esc(it.n + ': ' + (q.l || q.id)) + '">' + o + '</select></label>';
        }
        out += sec(it.n + ': ' + (q.l || q.id), q.note || '', body);
      });
    });
    var prob = extraProblem(x);
    return out + '<div class="bbvb-acc__cta"><button type="button" class="bbvb-btn bbvb-btn--primary" data-a="next" data-k="exnext' + x.id + '"' + (prob ? ' disabled' : '') + '>Continue</button>' +
      (prob ? '<span class="bbvb-acc__why">' + esc(prob) + ' to continue</span>' : '') + '</div>';
  }

  function selections() {                // one row per choice: [step id, label, value, thumbnail html, thumbnail background]
    var c = combo(), rows = [], kind = S.top ? topKind(S.top) : null, hasTop = kind !== 'n', bench = kind == null || kind === 'b';
    var sizeTxt = S.size != null ? sizeLabel() : '';
    if (sizeTxt && S.bowl && !M.oneBowl) sizeTxt += ', ' + bowlName().toLowerCase() + (M.bowlL ? '' : ' bowl');
    if (sizeTxt && needsHinge() && S.hinge) sizeTxt += ', ' + S.hinge.toLowerCase();
    rows.push([stepOn('size') ? 'size' : '', 'Size', sizeTxt, S.size != null && !M.sizeL ? String(+S.size) : '']);
    if (stepOn('top')) {
      var needCol = !!S.top && topColours(S.top).length > 0;
      var topDone = !!S.top && (!needCol || S.colour != null);
      var t = topDone && needCol ? LIB.tops[S.colour] : null;
      rows.push(['top', topWord(), topDone ? topLabel() + (kind === 'b' ? ', ' + thickLabel() : '') : '', t ? img(sized(file(t.f), 120, 120), '') : '', t ? t.bg : '']);
    }
    var f = S.fin != null ? LIB.fins[S.fin] : null;
    if (M.fins.length) rows.push([stepOn('fin') ? 'fin' : '', 'Cabinet finish', f ? f.n : '', f && f.f ? img(sized(file(f.f), 120, 120), '') : '', f ? f.bg : '']);
    if (frontsOn()) rows.push(['front', 'Cabinet fronts', S.front != null && M.fronts.items[S.front] ? M.fronts.items[S.front].n : 'Standard flat fronts', '', '']);
    M.picks.forEach(function (p) {
      if (!pickOn(p)) return;
      var pv = pickVal(p), it = p.list && pv != null ? p.list[pv] : null;
      rows.push([p.id, p.l, pickLabel(p) + (feeOn(p) && S.pq[p.id] ? ' \u00d7 ' + S.pq[p.id] : ''), it && it.f ? img(sized(file(it.f), 120, 120), '') : '', it ? '#fff' : '']);
    });
    if (hasTop) {
      if (bench && stepOn('basin')) {
        var bpic = '';
        if (typeof S.basin === 'number') bpic = M.basins[S.basin].k.img;
        else if (incBasinIndex() > -1) bpic = M.incBasin[incBasinIndex()].img;
        rows.push(['basin', 'Basin', S.basin != null && c ? basinLabel(false) : '', bpic ? img(sized(bpic, 120, 120), '') : '', bpic ? '#f4efe8' : '']);
      }
      if (stepOn('tap')) rows.push(['tap', 'Tap holes', S.tap && c ? tapLabel() : '', S.tap ? tapIcon(S.tap) : '']);
      if (M.wastes.length) {
        var w = S.waste ? byCode(M.wastes, S.waste) : null;
        rows.push([stepOn('waste') ? 'waste' : '', 'Plug & waste', w && c ? wasteLabel() : (w && M.wasteAuto ? w.n + ' (included)' : ''), w && w.img ? img(sized(w.img, 120), '') : '', w ? '#fff' : '']);
      }
    }
    if (M.power.length) {
      var pw = S.power ? byCode(M.power, S.power) : null;
      rows.push(['power', 'Power point', powerLabel(), pw && pw.img ? img(sized(pw.img, 120), '') : '', pw ? '#fff' : '']);
    }
    if (c && c.kitInc) rows.push(['', 'Plumbing kit', kitLabel(), '', '']);
    else if (M.kit) rows.push(['kit', 'Plumbing kit', S.kit ? kitLabel() : 'None', S.kit && M.kit.k.img ? img(sized(M.kit.k.img, 120), '') : '', S.kit ? '#fff' : '']);
    M.extras.forEach(function (x) {
      var list = extraChosen(x);
      rows.push([x.id, x.l, list.length ? list.map(function (it) { return extraLabel(x, it); }).join(', ') : 'None', list.length && list[0].img ? img(sized(list[0].img, 120), '') : '', list.length ? '#fff' : '']);
    });
    return rows;
  }

  function cartTable(ls, t) {
    var rows = ls.map(function (l) {
      return '<tr><td>' + esc(l.title) + '<small>' + (l.sub ? esc(l.sub) + ' \u00b7 ' : '') + esc(l.sku) + '</small></td><td>' + l.qty + '</td><td class="r">' + money(l.qty * l.p) + '</td></tr>';
    }).join('');
    return '<table class="bbvb-cart"><thead><tr><th scope="col">Item</th><th scope="col">Qty</th><th scope="col" class="r">Price</th></tr></thead><tbody>' + rows + '</tbody>' +
      '<tfoot><tr><td colspan="2">Total <small>Includes GST</small></td><td class="r">' + money(t.total) + '</td></tr></tfoot></table>' +
      saveLine(t);
  }

  function stepReview() {
    var ls = lines(), t = totals(ls);
    var out = '<div class="bbvb-review"><div class="bbvb-card"><h3 class="bbvb-card__h">What goes in your cart</h3>' + cartTable(ls, t) + '</div></div>';
    if (M.facts.length) out += '<ul class="bbvb-facts">' + M.facts.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>';
    if (SET.contact_note) out += '<p class="bbvb-contact">' + esc(SET.contact_note) + '</p>';
    if (SET.require_ack) {
      out += '<label class="bbvb-ack"><input type="checkbox" data-a="ack" data-k="ack"' + (S.ack ? ' checked' : '') + '><span>' + esc(SET.ack_text || 'I understand this vanity is made to order.') + '</span></label>';
    } else {
      out += '<div class="bbvb-mto">ADP makes this vanity to order in Australia. Check every choice above, because a made-to-order vanity can\u2019t be changed once it goes into production.</div>';
    }
    return out;
  }

  function doneView() {
    var d = S.done;
    return '<div class="bbvb-doneview"><span class="bbvb-doneview__tick">' + TICK + '</span>' +
      '<h2 class="bbvb-h" id="bbvb-h" tabindex="-1">Added to your cart</h2>' +
      '<p class="bbvb-lede">Your ' + esc(M.title) + ' and everything you chose with it are in your cart.</p>' +
      '<div class="bbvb-card">' + cartTable(d.lines, d.totals) + '</div>' +
      '<div class="bbvb-doneview__btns"><a class="bbvb-btn bbvb-btn--primary" href="' + esc(CFG.routes.cart) + '" data-nav="cart" data-k="donecart">View cart</a>' +
      '<button type="button" class="bbvb-btn bbvb-btn--ghost" data-a="finish" data-k="donekeep">Keep shopping</button></div></div>';
  }

  /* ---------- render ---------- */
  function sameNode(a, b) {
    if (a.nodeType !== b.nodeType || a.nodeName !== b.nodeName) return false;
    if (a.nodeType !== 1) return true;
    if (a.getAttribute('data-k') !== b.getAttribute('data-k')) return false;
    return a.nodeName !== 'IMG' || a.getAttribute('src') === b.getAttribute('src');
  }
  function patchNode(a, b) {
    if (a.nodeType !== 1) { if (a.nodeValue !== b.nodeValue) a.nodeValue = b.nodeValue; return; }
    var i, at;
    for (i = b.attributes.length - 1; i >= 0; i--) { at = b.attributes[i]; if (a.getAttribute(at.name) !== at.value) a.setAttribute(at.name, at.value); }
    for (i = a.attributes.length - 1; i >= 0; i--) { at = a.attributes[i]; if (at.name !== 'data-err' && !b.hasAttribute(at.name)) a.removeAttribute(at.name); }
    patchKids(a, b);
    if (a.nodeName === 'SELECT') { var o = b.querySelector('option[selected]'); if (o) a.value = o.value; }
    if (a.nodeName === 'INPUT' && a.type === 'checkbox') a.checked = b.hasAttribute('checked');
  }
  function patchKids(a, b) {
    var x = a.firstChild, y = b.firstChild, next;
    while (y) {
      next = y.nextSibling;
      if (x && sameNode(x, y)) { patchNode(x, y); x = x.nextSibling; }
      else a.insertBefore(y, x);
      y = next;
    }
    while (x) { next = x.nextSibling; a.removeChild(x); x = next; }
  }
  function paint(el, html, fresh) {      // fresh = throw the old markup away (new step)
    if (fresh || !el.firstChild) { el.innerHTML = html; return; }
    var t = document.createElement('template');
    t.innerHTML = html;
    patchKids(el, t.content);
  }
  var LEDE = {
    size: function () {
      if (M.sizes.length === 1) return 'This vanity is made in one size, ' + sizeText(M.sizes[0]) + '. Pick ' + (M.bowlHead ? 'the ' + M.bowlHead.toLowerCase() : 'where the basin sits') + '.';
      if (M.oneBowl) return M.sizeL ? 'Pick the size.' : 'Pick the width.';
      if (M.bowlHead) return 'Pick the ' + (M.sizeL ? 'size' : 'width') + ', then the ' + M.bowlHead.toLowerCase() + '.';
      return M.sizeL ? 'Pick the size, then where the basin sits.' : 'Pick the width, then where the basin sits.';
    },
    top: function () {
      if (!M.hasMoulded) return 'Pick a material, then a colour.';
      return M.topIds.some(function (t) { return topKind(t) === 'b'; }) ? 'Pick a top. A moulded top has the basin built in. A benchtop comes in a choice of colours and takes a separate basin.' : 'Pick a top.';
    },
    fin: function () { return M.fronts ? 'Every finish is the same price. ' + (M.fronts.w || 'Polyurethane') + ' finishes can also have classic cabinet fronts.' : 'Every finish is the same price.'; },
    front: function () { return 'Flat fronts are standard. Classic fronts are an optional upgrade, made in the polyurethane finish you chose.'; },
    basin: function () {
      var c = combo();
      if (M.incBasin) return 'The basin is included with this vanity. Pick its colour.';
      if (!c.basins.length) return 'ADP lists no basin of its own for this size and bowl position, so the vanity comes without one. Contact us if you\u2019d like help choosing a basin to suit.';
      return 'These are the ADP basins that fit a ' + sizeLabel() + (M.oneBowl || M.bowlL ? '' : ' ' + bowlName().toLowerCase()) + ' vanity.' + (c.nb > 1 ? ' This vanity takes two basins, so two are added.' : '');
    },
    tap: function () {
      var c = combo();
      return (S.top && topKind(S.top) === 'm' ? 'The top is supplied with the tap holes you choose.' : 'ADP drills the benchtop to order.') + (c.nb > 1 ? ' Your choice applies to both basins.' : '');
    },
    waste: function () {
      var c = combo(), inc = M.wastes.some(function (w) { return w.inc; });
      return (inc ? 'Chrome is included with the vanity.' : 'Pick a finish.') + (c.nb > 1 ? ' A double vanity needs two.' : '');
    },
    thick: function () { return 'The standard thickness is included. A thicker edge is an optional upgrade.'; },
    power: function () { return String(M.powerNote || 'Fitted inside a drawer by ADP').replace(/\.\s*$/, '') + '. Pick None if you don\u2019t need one.'; },
    kit: function () {
      var c = combo();
      return 'Keeps the waste pipe clear of the cabinet storage.' + (c && c.nb > 1 ? ' A double vanity needs two.' : '');
    },
    review: function () { return 'Check your choices above, then add everything to your cart in one go.'; }
  };
  var BODY = { size: stepSize, top: stepTop, thick: stepThick, fin: stepFin, front: stepFront, basin: stepBasin, tap: stepTap, waste: stepWaste, power: stepPower, kit: stepKit, review: stepReview };

  function ledeOf(id) { var st = stepDef(id), d = st && (st.pick || st.extra); return d ? d.lede : LEDE[id](); }
  function bodyOf(id) { var st = stepDef(id); return st && st.pick ? stepPick(st.pick) : (st && st.extra ? stepExtra(st.extra) : BODY[id]()); }

  function alertHtml() {
    var e = S.error, link = ' <a href="' + esc(CFG.routes.cart) + '" data-nav="cart">View cart</a>';
    if (!e) return '';
    if (e.kind === 'partial') return '<div class="bbvb-alert" role="alert"><b>Check your cart first.</b> Some items from an earlier attempt are already in your cart. Remove them there before adding this vanity again.' + (e.text ? ' The store said: ' + esc(e.text) : '') + link + '</div>';
    if (e.kind === 'earlier') return '<div class="bbvb-alert" role="alert"><b>A vanity from an earlier attempt is already in your cart.</b> It has the choices you made then. View your cart to check it. To add this one as well, press Add to cart again.' + link + '</div>';
    if (e.kind === 'unconfirmed') return '<div class="bbvb-alert" role="alert"><b>We couldn\u2019t confirm that your vanity was added.</b> Check your cart before trying again.' + link + '</div>';
    if (e.network) return '<div class="bbvb-alert" role="alert"><b>We couldn\u2019t reach the store.</b> Check your connection and try again.</div>';
    return '<div class="bbvb-alert" role="alert"><b>That didn\u2019t go into your cart.</b> ' + esc(e.text || 'Please try again.') + '</div>';
  }
  function renderHead() {
    var a = activeSteps(), cur = stepIndex(S.step);
    var req = a.filter(function (s) { return required(s.id); });
    var got = req.filter(function (s) { return reachable(s.id) && !problem(s.id); }).length;
    paint($('.bbvb-steps'), '');
    $('.bbvb-brand__eyebrow').textContent = SET.dialog_label || 'Design your vanity';
    $('.bbvb-brand__title').textContent = M.title;
    paint($('.bbvb-progress'), S.done ? '' : '<div class="bbvb-progress__t"><b>' + got + ' of ' + req.length + ' required choices made</b><span>' + esc(a[cur].l) + '</span></div>' +
      '<div class="bbvb-progress__bar" role="progressbar" aria-valuemin="0" aria-valuemax="' + req.length + '" aria-valuenow="' + got + '" aria-label="Required choices made"><i style="width:' + (req.length ? Math.round(got / req.length * 100) : 100) + '%"></i></div>');
  }
  function brief(id, rows) {             // one line for a step that is folded away: [text, thumbnail html, thumbnail background]
    var i, r = null;
    if (id === 'top') { if (!S.top || (topColours(S.top).length && S.colour == null)) return ['', '', '']; }
    if (id === 'thick') return [S.top && topKind(S.top) === 'b' ? thickLabel() : '', '', ''];
    if (id === 'kit') return [S.kit ? kitLabel() : 'None', '', ''];
    for (i = 0; i < rows.length; i++) if (rows[i][0] === id) { r = rows[i]; break; }
    if (!r) return ['', '', ''];
    return [id === 'top' ? topLabel() : r[2], r[3] || '', r[4] || ''];
  }
  function renderMain(stepChanged) {     // every step on one page: the open one in full, the others folded to a line
    var main = $('.bbvb-main');
    if (S.done) { paint(main, doneView(), stepChanged); if (stepChanged) main.scrollTop = 0; return; }
    var a = activeSteps(), rows = selections(), t = totals(lines());
    var html = a.map(function (st, i) {
      var id = st.id, open = id === S.step, ok = reachable(id), last = id === 'review';
      var done = ok && !open && !last && S.seen[id] && !problem(id);
      var req = required(id);
      var tag = last ? '' : '<span class="bbvb-acc__tag' + (req ? ' is-req' : '') + '">' + (req ? 'Required' : 'Optional') + '</span>';
      var num = '<span class="bbvb-acc__n" aria-hidden="true">' + (done ? '✓' : i + 1) + '</span>';
      var out = '<section class="bbvb-acc' + (open ? ' is-open' : (done ? ' is-done' : (ok ? ' is-todo' : ' is-locked'))) + '" data-sec="' + id + '" data-k="acc' + id + '">';
      if (open) {
        var prob = problem(id);
        out += '<div class="bbvb-acc__open" data-k="open' + id + '"><div class="bbvb-acc__top">' + num +
          '<div class="bbvb-acc__ttl"><p class="bbvb-eyebrow">Step ' + (i + 1) + ' of ' + a.length + tag + '</p>' +
          '<h2 class="bbvb-h" id="bbvb-h" tabindex="-1">' + esc(st.h) + '</h2><p class="bbvb-lede">' + esc(ledeOf(id)) + '</p></div></div>' +
          (S.restored ? '<div class="bbvb-notice" role="status">Your earlier choices are still here. Check them before you add to cart.</div>' : '') +
          (S.notice && (id === 'size' || id === 'basin') ? '<div class="bbvb-notice" role="status">' + esc(S.notice) + '</div>' : '') +
          bodyOf(id);
        if (last) {
          out += alertHtml() + '<div class="bbvb-acc__cta"><button type="button" class="bbvb-btn bbvb-btn--primary bbvb-btn--xl" data-a="add" data-k="addmain"' + (prob || S.busy ? ' disabled' : '') + '>' +
            (S.busy ? 'Adding…' : 'Add to cart · ' + money(t.total)) + '</button>' + (prob ? '<span class="bbvb-acc__why">' + esc(prob) + ' to continue</span>' : '') + '</div>';
        }
        out += '</div>';
      } else {
        var b = ok ? brief(id, rows) : ['', '', ''];
        out += '<button type="button" class="bbvb-acc__bar" data-a="go" data-v="' + id + '" data-k="bar' + id + '"' + (ok ? '' : ' disabled') +
          ' aria-label="Step ' + (i + 1) + ' of ' + a.length + ': ' + esc(st.l) + (b[0] ? ', ' + esc(b[0]) : '') + (done ? '. Change' : '') + '">' + num +
          '<span class="bbvb-acc__l">' + esc(st.l) + tag + '</span>' +
          (b[0] ? '<span class="bbvb-acc__v">' + (b[1] ? '<span class="bbvb-sel__sw"' + (b[2] ? ' style="background:' + esc(b[2]) + '"' : '') + '>' + b[1] + '</span>' : '') + '<span>' + esc(b[0]) + '</span></span>' : '<span class="bbvb-acc__v"></span>') +
          (ok ? '<span class="bbvb-acc__act">' + (done ? 'Change' : (last ? 'Review' : 'Choose')) + '</span>' : '') + '</button>';
      }
      return out + '</section>';
    }).join('');
    paint(main, html);
  }
  function showOpen(smooth) {            // bring the open step to the top of the page
    var main = $('.bbvb-main'), el = main.querySelector('.bbvb-acc.is-open');
    if (!el) return;
    var top = Math.max(0, Math.round(el.getBoundingClientRect().top - main.getBoundingClientRect().top + main.scrollTop - 12));
    var calm = false;
    try { calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    if (smooth && !calm && main.scrollTo) { try { main.scrollTo({ top: top, behavior: 'smooth' }); return; } catch (e) {} }
    main.scrollTop = top;
  }
  function renderSide() {
    var side = $('.bbvb-side');
    var c = combo(), v = variant(), ls = S.done ? S.done.lines : lines(), t = S.done ? S.done.totals : totals(ls);
    var hz = M.hero ? ' style="transform:scale(' + M.hero.z + ');transform-origin:50% ' + M.hero.oy + '%"' : '';
    var hero = heroSrc();
    var h = '<div class="bbvb-sheet-head"><span>Your vanity</span><button type="button" class="bbvb-link" data-a="sheet" data-k="sheetclose">Close</button></div><div class="bbvb-sum" tabindex="0" role="region" aria-label="Summary of your vanity">' +
      '<div class="bbvb-sum__hero' + (hz ? ' is-zoom' : '') + '">' + (hero ? '<img decoding="async" alt="' + esc(M.title) + '" src="' + esc(sized(hero, 900)) + '"' + hz + '>' : '') + '</div>' +
      '<p class="bbvb-sum__cap">The picture is a guide. It doesn\u2019t change with your colour choices.</p>';
    var f = S.fin != null && stepOn('fin') ? LIB.fins[S.fin] : null;
    var tp = S.top && topKind(S.top) !== 'n' && S.colour != null ? LIB.tops[S.colour] : null;
    if (f || tp) {
      h += '<div class="bbvb-pal">' + [[tp, M.hasMoulded ? 'Your top' : 'Your benchtop'], [f, 'Your cabinet finish']].map(function (x) {
        return x[0] ? '<figure><span style="background:' + esc(x[0].bg || '#eee') + '">' + (x[0].f ? img(sized(file(x[0].f), 400, 250), '') : '') + '</span><figcaption><small>' + x[1] + '</small>' + esc(x[0].n) + '</figcaption></figure>' : '';
      }).join('') + '</div>';
    }
    var codeBits = [M.depth, M.mount].filter(Boolean).map(esc);
    if (v) codeBits.push('Code <b>' + esc(v.sku) + '</b>');
    h += '<h3 class="bbvb-sum__title">' + esc(M.title) + '</h3>' +
      '<p class="bbvb-sum__code">' + codeBits.join(' \u00b7 ') + '</p>';
    if (M.facts.length && !S.done) h += '<ul class="bbvb-facts">' + M.facts.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>';
    if (S.step !== 'review' && !S.done) {
      h += '<ul class="bbvb-sel">' + selections().map(function (r) {
        var empty = !r[2];
        return '<li><span class="bbvb-sel__sw"' + (r[4] ? ' style="background:' + esc(r[4]) + '"' : '') + '>' + (r[3] || '') + '</span>' +
          '<span><span class="bbvb-sel__k">' + esc(r[1]) + '</span><span class="bbvb-sel__v' + (empty ? ' is-empty' : '') + '">' + esc(empty ? 'Not chosen yet' : r[2]) + '</span></span>' +
          (r[0] && reachable(r[0]) && r[0] !== S.step ? '<button type="button" class="bbvb-link" data-a="go" data-v="' + r[0] + '" data-k="sum' + r[0] + esc(r[1]) + '" aria-label="' + (empty ? 'Choose ' : 'Edit ') + esc(r[1].toLowerCase()) + '">' + (empty ? 'Choose' : 'Edit') + '</button>' : '<span></span>') + '</li>';
      }).join('') + '</ul>';
    }
    if (c && !S.done && !M.noPlan) h += '<div class="bbvb-plan">' + plan() + '<p class="bbvb-plan__cap">Top view, not to scale</p></div>';
    if (ls.length) {
      h += '<ul class="bbvb-lines">' + ls.map(function (l) {
        return '<li><span>' + (l.qty > 1 ? l.qty + ' \u00d7 ' : '') + esc(l.kind === 'vanity' ? 'Vanity' : l.title.replace(/^ADP /, '')) + '<small>' + esc(l.sub) + '</small></span><span>' + money(l.qty * l.p) + '</span></li>';
      }).join('') + '</ul>';
    }
    if (!S.done && started()) h += '<p class="bbvb-sum__reset"><button type="button" class="bbvb-link" data-a="reset" data-k="reset">Start again</button></p>';
    h += '</div><div class="bbvb-sum__foot">';
    if (ls.length) {
      h += '<div class="bbvb-total"><span class="bbvb-total__k">Total<small>Includes GST</small></span><span class="bbvb-total__v">' + money(t.total) + '</span></div>' +
        saveLine(t);
    } else {
      h += '<div class="bbvb-total"><span class="bbvb-total__k">From<small>Includes GST</small></span><span class="bbvb-total__v">' + money(fromPrice()) + '</span></div>';
    }
    paint(side, h + '</div>');
  }
  function renderFoot() {
    var foot = $('.bbvb-foot');
    if (S.done) { paint(foot, ''); foot.hidden = true; return; }
    foot.hidden = false;
    var onReview = S.step === 'review', prob = problem(S.step), canReview = reachable('review');
    var t = totals(lines());
    paint(foot,
      '<button type="button" class="bbvb-foot__total" data-a="sheet" data-k="sheet"><small>View your vanity</small><b>' + (t.total ? money(t.total) : 'From ' + money(fromPrice())) + '</b></button>' +
      '<span class="bbvb-foot__msg" role="status">' + esc(prob ? prob + ' to continue' : '') + '</span>' +
      (onReview
        ? '<button type="button" class="bbvb-btn bbvb-btn--primary" data-a="add" data-k="next"' + (prob || S.busy ? ' disabled' : '') + '><span>' + (S.busy ? 'Adding…' : 'Add to cart<span class="bbvb-btn__l"> · ' + money(t.total) + '</span>') + '</span></button>'
        : '<button type="button" class="bbvb-btn bbvb-btn--primary" data-a="go" data-v="review" data-k="next"' + (canReview ? '' : ' disabled') + '><span>Review<span class="bbvb-btn__l"> &amp; add to cart</span></span></button>'));
  }
  function sheetShown() { return !!(S && S.sheet && mq && mq.matches); }
  function render(stepChanged) {
    var active = shadow.activeElement;
    var had = active && root.contains(active) ? active : null;
    var key = had ? had.getAttribute('data-k') : null;
    root.classList.toggle('is-sheet', !!S.sheet);
    root.classList.toggle('is-done', !!S.done);
    renderHead(); renderMain(!!stepChanged); renderSide(); renderFoot();
    sweep();
    var cover = sheetShown();            // on a phone the summary sheet covers the rest: keep focus out of what is behind it
    ['.bbvb-head', '.bbvb-main', '.bbvb-foot'].forEach(function (sel) { var el = $(sel); if (cover) el.setAttribute('inert', ''); else el.removeAttribute('inert'); });
    if (!isOpen) return;
    if (stepChanged) {
      var hd = shadow.getElementById('bbvb-h');
      if (hd) hd.focus({ preventScroll: true });
      if (!S.done) showOpen(stepChanged !== 'jump');
    } else if (key && !root.contains(shadow.activeElement)) {
      var el = root.querySelector('[data-k="' + key.replace(/["\\]/g, '\\$&') + '"]');
      if (el && !el.disabled) el.focus({ preventScroll: true });
    }
  }

  /* ---------- actions ---------- */
  function go(id) {
    if (!reachable(id)) return false;
    var changed = S.step !== id;
    S.step = id; S.sheet = false; S.seen[id] = 1;
    return changed;
  }
  var QUIET = { add: 1, sheet: 1, go: 1, next: 1, back: 1, bf: 1, ack: 1, finish: 1 };   // these don't change the build
  var ACT = {
    size: function (v) {
      v = idx(v);
      if (v == null || M.sizes.indexOf(v) < 0) return;
      S.size = v;
      var bs = bowlsFor(v);
      if (!bs.some(function (b) { return b.id === S.bowl; })) S.bowl = bs.length === 1 ? bs[0].id : null;
      comboChanged();
    },
    bowl: function (v) { v = str(v); if (v && byId(BOWLS, v) && S.size != null && M.combos[S.size + '|' + v]) { S.bowl = v; comboChanged(); } },
    hinge: function (v) { v = idx(v); if (v != null && needsHinge() && typeof M.hinge.opts[v] === 'string') S.hinge = M.hinge.opts[v]; },
    top: function (v) {
      v = str(v);
      var c = combo();
      if (!v || !byId(LIB.topGroups, v) || !c || !c.tops[v]) return;
      if (S.top !== v) { S.top = v; S.colour = null; }
      var t = S.thick === 'std' ? null : byId(M.thick, S.thick);
      if (S.thick !== 'std' && !(t && thickAllowed(t))) S.thick = 'std';
      comboChanged(true);                                    // the tap holes, and some questions, depend on the top
    },
    colour: function (v) { v = idx(v); if (v != null && S.top && topColours(S.top).indexOf(v) > -1) S.colour = v; },
    thick: function (v) { v = str(v); var t = v ? byId(M.thick, v) : null; if (v === 'std' || (t && thickAllowed(t))) S.thick = v; },
    fin: function (v) { v = idx(v); if (v != null && finsFor().indexOf(v) > -1) { S.fin = v; if (!frontsOn()) S.front = null; } },
    front: function (v) {                                    // 'std' = flat fronts, or the index of a classic design
      if (!frontsOn()) return;
      if (v === 'std') { S.front = null; return; }
      v = idx(v);
      if (v != null && M.fronts.items[v]) S.front = v;
    },
    bf: function (v) { v = str(v); S.bf = v === 'all' || (v && byId(LIB.basinTypes, v)) ? v : 'all'; },
    basin: function (v) {
      if (v === 'none') { if (M.incBasin) return; S.basin = 'none'; }
      else if (typeof v === 'string' && /^i\d{1,3}$/.test(v)) { if (!M.incBasin || !M.incBasin[+v.slice(1)] || (M.vary === 'basin' && !varyHas(+v.slice(1)))) return; S.basin = v; }
      else {
        v = idx(v);
        var b = v == null ? null : M.basins[v];
        if (!b || M.incBasin || !b.ok || b.oos || allowedBasins().indexOf(v) < 0) return;
        S.basin = v;
      }
      S.notice = null;
      if (S.basin === 'none' && S.tap === '0-basin') S.tap = null;
    },
    bcol: function (v) { return ACT.basin(v); },           // a colour chip on the chosen basin
    tap: function (v) { v = str(v); if (v && tapsFor().some(function (t) { return t.id === v; }) && !(v === '0-basin' && S.basin === 'none')) S.tap = v; },
    waste: function (v) { v = str(v); if (v && byCode(M.wastes, v)) S.waste = v; },
    power: function (v) { v = str(v); S.power = v && byCode(M.power, v) ? v : null; if (!needsSide()) S.side = null; },
    side: function (v) { v = str(v); if (v && needsSide() && sideOpts().indexOf(v) > -1) S.side = v; },
    kit: function (v) { S.kit = (v === '1' || v === 1 || v === true) && !!M.kit; },
    pick: function (v) {                                     // "<step id>|<index>"
      var a = String(v == null ? '' : v).split('|'), st = stepDef(a[0]), p = st && st.pick, i = idx(a[1]);
      if (!p || !pickOn(p) || i == null) return;
      if (p.opts ? typeof p.opts[i] !== 'string' : p.items.indexOf(i) < 0) return;
      if (M.vary === p.id && !varyHas(i)) return;
      S.pk[p.id] = i;
      if (!feeOn(p)) delete S.pq[p.id];
      if (M.vary === p.id) comboChanged();
    },
    pcol: function (v) { return ACT.pick(v); },              // a finish chip on the chosen style
    pq: function (v) {                                       // "<step id>|<how many>" for a choice charged for each one fitted
      var a = String(v == null ? '' : v).split('|'), st = stepDef(a[0]), p = st && st.pick, n = idx(a[1]);
      if (!p || !pickOn(p) || !feeOn(p)) return;
      if (n == null || n < p.fee.min || n > p.fee.max) delete S.pq[p.id]; else S.pq[p.id] = n;
    },
    ex: function (v) {                                       // "<step id>|<sku>": on or off
      var a = String(v == null ? '' : v).split('|'), st = stepDef(a[0]), x = st && st.extra, it = x ? byCode(x.items, a[1]) : null;
      if (!it) return;
      var e = S.ex[x.id] || (S.ex[x.id] = Object.create(null));
      if (e[it.c]) { delete e[it.c]; return; }
      if (x.single) x.items.forEach(function (o) { delete e[o.c]; });   // one of them at most
      it.x.forEach(function (c) { delete e[c]; });           // extras that cannot go together
      e[it.c] = Object.create(null);
    },
    exq: function (v) {                                      // "<step id>|<sku>|<question>|<answer>"
      var a = String(v == null ? '' : v).split('|'), st = stepDef(a[0]), x = st && st.extra, it = x ? byCode(x.items, a[1]) : null, q = null, e, n;
      if (!it || !S.ex[x.id] || !S.ex[x.id][it.c]) return;
      it.ask.forEach(function (k) { if (k.id === a[2]) q = k; });
      if (!q) return;
      e = S.ex[x.id][it.c];
      if (q.opts) { if (q.opts.indexOf(a[3]) > -1) e[q.id] = a[3]; }
      else { n = idx(a[3]); if (n == null || n < q.min || n > q.max) delete e[q.id]; else e[q.id] = n; }
    },
    exnone: function (v) { var st = stepDef(str(v) || ''), x = st && st.extra; if (x) delete S.ex[x.id]; },
    ack: function (v) { S.ack = v === true || v === 'true' || v === '1'; },
    sheet: function () { S.sheet = !S.sheet; },
    reset: function () { var u = S.unsettled; S = fresh(); S.unsettled = u; return true; },
    go: function (v) { return go(v); },
    next: function () { var a = activeSteps(), i = stepIndex(S.step); if (!problem(S.step) && i < a.length - 1) return go(a[i + 1].id); },
    back: function () { var a = activeSteps(), i = stepIndex(S.step); if (i > 0) return go(a[i - 1].id); },
    add: function () { addToCart(); },
    finish: function () { close(); }
  };
  function act(name, value) {
    if (!M || !S || !Object.prototype.hasOwnProperty.call(ACT, name)) return;
    if (S.busy) return;                                      // nothing changes while the cart request is out
    if (S.done && name !== 'finish') return;
    S.restored = false;
    if (!QUIET[name]) { S.error = null; S.ack = false; S.build = null; }   // the build changed: new id, and the customer confirms it again
    var r = ACT[name](value);
    if (!S || !root) return;
    var sid = secOf(name, value);                            // the open step is finished: fold it and open the next one
    if (sid && !S.done && S.step === sid && !problem(sid) && finishes(name, value)) {
      var to = nextOpen(sid);
      if (to && go(to)) r = true;
    }
    if (!S.done && !reachable(S.step)) {                     // guard: never sit on a step the choices no longer allow
      var a = activeSteps(), i;
      for (i = 0; i < a.length; i++) if (problem(a[i].id) || i === a.length - 1) { S.step = a[i].id; break; }
      r = true;
    }
    if (!S.done && name !== 'add' && name !== 'finish') persist();
    render(r === true);
    if (name === 'sheet' && isOpen && mq && mq.matches) {    // move focus with the sheet
      var to = S.sheet ? root.querySelector('.bbvb-sheet-head .bbvb-link') : root.querySelector('.bbvb-foot__total');
      if (to) to.focus({ preventScroll: true });
    }
  }

  /* ---------- cart ---------- */
  function headerSectionId() {           // Turbo's header section, for the mini cart refresh
    try {
      var cc = document.querySelectorAll('.cart-container');
      for (var i = 0; i < cc.length; i++) {
        var s = cc[i].closest ? cc[i].closest('.shopify-section') : null;
        if (s && s.id && s.id.indexOf('shopify-section-') === 0) return s.id.slice('shopify-section-'.length);
      }
    } catch (e) {}
    return '';
  }
  function post(sent) {
    var body = { items: sent.items }, sid = headerSectionId();
    if (sid) { body.sections = sid; body.sections_url = window.location.pathname; }
    return request(CFG.routes.cart_add, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }, T_CART_ADD).then(function (r) {
      var d = r.data;
      r.ok = !!(r.okHttp && d && !(d.status && d.status >= 400) && d.items && d.items.length >= sent.items.length);
      r.text = d && !r.ok && r.status >= 400 && r.status < 500 ? String(d.description || d.message || '') : '';
      return r;
    });
  }
  function cartStatus(build, items) {    // is this build in the cart?  'all' | 'some' | 'none' | 'unknown'
    return request(CFG.routes.cart + '.js', { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } }, T_CART_READ).then(function (r) {
      if (!r.okHttp || !r.data || !r.data.items) return 'unknown';
      var mine = r.data.items.filter(function (i) { return i.properties && i.properties._build === build; });
      if (!mine.length) return 'none';
      if (!items.length) return 'some';                      // lines of this build are there, but what was sent is not known
      var all = items.every(function (it) {
        return mine.some(function (l) { return (l.variant_id === it.id || l.id === it.id) && l.quantity >= it.quantity; });
      });
      return all ? 'all' : 'some';
    });
  }
  function syncThemeCart(sections) {     // best effort: bring Turbo's cart count and mini cart up to date
    try {
      var html = null, k;
      if (sections) for (k in sections) if (typeof sections[k] === 'string') { html = sections[k]; break; }
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var count = doc.querySelector('.cart_count');
      if (count) [].forEach.call(document.querySelectorAll('.cart_count'), function (el) { el.textContent = count.textContent; });
      var freshCart = doc.querySelector('.cart_content');
      if (freshCart) [].forEach.call(document.querySelectorAll('.cart_content'), function (el) { el.innerHTML = freshCart.innerHTML; });
    } catch (e) {}
  }
  function refreshThemeCart() {          // same, when the add was confirmed from the cart instead of from the reply
    var sid = headerSectionId();
    if (!sid) return;
    request(window.location.pathname + '?sections=' + encodeURIComponent(sid), { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }, T_CART_READ).then(function (r) {
      if (r.okHttp && r.data) syncThemeCart(r.data);
    });
  }
  function sameItems(a, b) {             // the same lines, whatever their order, build id or grouping
    function norm(list) {
      return (list || []).map(function (it) {
        var pr = {}, k;
        for (k in (it.properties || {})) if (k !== '_build') pr[k] = it.properties[k];
        return JSON.stringify([it.id, it.quantity, Object.keys(pr).sort().map(function (key) { return [key, pr[key]]; })]);
      }).sort().join('|');
    }
    return norm(a) === norm(b);
  }
  /* One attempt to add the build. Resolves ok | partial | unconfirmed | refused (refused = nothing of it is in the cart). */
  function attempt(st, mode) {
    var sent = payload(mode);
    st.unsettled = { build: st.build, items: sent.items };
    persist();                                               // on record before the request leaves, in case the page is left mid-way
    return post(sent).then(function (res) {
      if (res.ok) { st.unsettled = null; return { kind: 'ok', sections: res.data.sections, sent: sent, response: res.data }; }
      return cartStatus(st.build, sent.items).then(function (where) {
        if (where === 'unknown') return { kind: 'unconfirmed' };
        if (where === 'all') { st.unsettled = null; return { kind: 'ok', sections: null, sent: sent, response: res.data }; }
        if (where === 'some') return { kind: 'partial', text: res.text };
        if (res.network) return { kind: 'error', network: true };   // no answer: it may still arrive, so this attempt stays unsettled
        st.unsettled = null;
        return { kind: 'refused', status: res.status, text: res.text };
      });
    });
  }
  function submit(st) {
    var nested = SET.nest !== false;
    function send() {
      return attempt(st, nested ? 'nested' : 'flat').then(function (first) {
        if (first.kind !== 'refused') return first;
        if (!nested || (first.status !== 422 && first.status !== 400)) return { kind: 'error', text: first.text };
        return attempt(st, 'flat').then(function (second) {  // the store refused grouped lines: try once as ordinary lines
          return second.kind === 'refused' ? { kind: 'error', text: second.text || first.text } : second;
        });
      });
    }
    if (!st.unsettled) return send();
    var old = st.unsettled;                                  // an earlier attempt may have reached the cart: settle that first
    return cartStatus(old.build, old.items).then(function (where) {
      if (where === 'unknown') return { kind: 'unconfirmed' };
      if (where === 'some') return { kind: 'partial' };
      st.unsettled = null;
      if (where === 'none') return send();
      if (sameItems(old.items, payload('flat').items)) return { kind: 'ok', sections: null, sent: old, response: null };   // this very build is already there
      return { kind: 'earlier' };                            // a different, complete build is there: say so once, then let them add this one too
    });
  }
  /* ---------- keeping the choices for this tab (a reload or a trip to the cart must not lose eight steps) ---------- */
  var KEEP = ['size', 'bowl', 'hinge', 'top', 'colour', 'thick', 'fin', 'front', 'basin', 'tap', 'waste', 'power', 'side', 'kit', 'pk', 'pq', 'ex'];
  function own(o, k) { return !!o && typeof o === 'object' && Object.prototype.hasOwnProperty.call(o, k); }
  function storeKey() { return 'bbvb:' + CFG.product.handle; }
  function persist() {
    try {
      if (!S || !M || !CFG || CFG.design_mode) return;
      if (!S.unsettled && !started()) { forget(); return; }       // nothing worth keeping
      var c = {};
      KEEP.forEach(function (k) { c[k] = S[k]; });
      window.sessionStorage.setItem(storeKey(), JSON.stringify({ v: 3, dv: M.dv, t: Date.now(), step: S.step, seen: Object.keys(S.seen), c: c, u: S.unsettled }));
    } catch (e) {}
  }
  function forget() { try { window.sessionStorage.removeItem(storeKey()); } catch (e) {} }
  function restore() {                   // replay the saved choices through the same checks as a click
    var d = null, raw = null, i, now = Date.now();
    if (!CFG || CFG.design_mode) return;
    try { raw = window.sessionStorage.getItem(storeKey()); } catch (e) { return; }
    if (raw == null) return;
    try { d = JSON.parse(raw); } catch (e) { d = null; }
    if (!d || typeof d !== 'object' || d.v !== 3 || !d.c || typeof d.c !== 'object' || d.dv !== M.dv ||
        typeof d.t !== 'number' || !(now - d.t < 12 * 3600 * 1000) || d.t > now + 60000) { forget(); return; }
    var c = d.c;
    try {
      ACT.size(c.size); ACT.bowl(c.bowl);
      if (typeof c.hinge === 'string' && M.hinge) ACT.hinge(M.hinge.opts.indexOf(c.hinge));
      ACT.top(c.top); ACT.colour(c.colour); ACT.thick(c.thick); ACT.fin(c.fin);
      if (typeof c.front === 'number') ACT.front(c.front);
      if (M.vary === 'basin' && c.basin != null && combo()) ACT.basin(c.basin);      // the basin picks the variant: it goes in before anything that depends on it
      M.picks.forEach(function (p) {
        if (own(c.pk, p.id) && typeof c.pk[p.id] === 'number') ACT.pick(p.id + '|' + c.pk[p.id]);
        if (own(c.pq, p.id) && typeof c.pq[p.id] === 'number') ACT.pq(p.id + '|' + c.pq[p.id]);
      });
      M.extras.forEach(function (x) {
        var e = own(c.ex, x.id) ? c.ex[x.id] : null;
        x.items.forEach(function (it) {
          var a = own(e, it.c) ? e[it.c] : null;
          if (!a || typeof a !== 'object') return;
          if (!(S.ex[x.id] && S.ex[x.id][it.c])) ACT.ex(x.id + '|' + it.c);
          it.ask.forEach(function (q) { if (own(a, q.id) && (typeof a[q.id] === 'string' || typeof a[q.id] === 'number')) ACT.exq(x.id + '|' + it.c + '|' + q.id + '|' + a[q.id]); });
        });
      });
      if (c.basin != null && combo()) ACT.basin(c.basin);
      ACT.tap(c.tap); ACT.waste(c.waste);
      ACT.power(c.power); ACT.side(c.side);
      if (c.kit === true) ACT.kit(true);
    } catch (e) { S = fresh(); }
    S.notice = null;
    S.restored = started();
    var u = d.u;
    if (u && typeof u === 'object' && typeof u.build === 'string' && /^[A-Z0-9-]{4,24}$/.test(u.build)) {
      var good = Array.isArray(u.items) && u.items.length > 0 && u.items.length <= 20 && u.items.every(function (it) {
        return it && typeof it === 'object' && typeof it.id === 'number' && typeof it.quantity === 'number';
      });
      S.unsettled = { build: u.build, items: good ? u.items : [] };   // a damaged list still names the build: the cart is checked for it
    }
    var a = activeSteps(), seen = Array.isArray(d.seen) ? d.seen : [];
    S.step = a[0].id;
    for (i = 0; i < a.length; i++) {     // back to the step they were on, as far as the choices still allow
      if (!reachable(a[i].id)) break;
      if (seen.indexOf(a[i].id) > -1) S.seen[a[i].id] = 1;
    }
    for (i = 0; i < a.length; i++) {
      if (!reachable(a[i].id)) break;
      S.step = a[i].id;
      if (a[i].id === d.step) break;
    }
    S.seen[S.step] = 1;
  }
  function addToCart() {
    if (S.busy || S.done || problem('review')) return;
    var st = S, gen = generation, ls = lines(), tt = totals(ls);
    if (!st.build) st.build = buildId();
    st.busy = true; st.error = null;
    render(false);
    submit(st).catch(function () { return { kind: 'unconfirmed' }; }).then(function (out) {
      if (gen !== generation || S !== st) return;
      st.busy = false;
      if (out.kind !== 'ok') {
        st.error = out;
        persist();
        render(false);
        var al = root.querySelector('.bbvb-alert');
        if (al && al.scrollIntoView) al.scrollIntoView({ block: 'center' });
        return;
      }
      if (out.sections) syncThemeCart(out.sections); else refreshThemeCart();
      try {
        document.dispatchEvent(new CustomEvent('bbvb:added', { detail: { items: out.sent.items, build: st.build, response: out.response } }));
      } catch (e) {}
      st.done = { lines: ls, totals: tt };
      st.sheet = false;
      forget();
      if (SET.after_add === 'cart') { leaveTo(CFG.routes.cart); return; }
      render(true);
    });
  }

  /* ---------- history: the browser's Back button closes the dialog ---------- */
  function onEntry() { try { return !!(window.history.state && window.history.state.bbvb); } catch (e) { return false; } }
  function pushEntry() {
    if (!CFG || CFG.design_mode) return;
    if (backTimer) {                                         // closed a moment ago and not stepped back yet: keep that entry
      window.clearTimeout(backTimer); backTimer = null; backPending = false; pushAfterBack = false;
      if (onEntry()) { pushed = true; return; }
    }
    if (backPending) { pushAfterBack = true; return; }
    try { window.history.pushState({ bbvb: 1 }, ''); pushed = true; } catch (e) { pushed = false; }
  }
  function settleBack() {
    backPending = false;
    if (pushAfterBack) { pushAfterBack = false; if (isOpen) pushEntry(); }
  }
  function dropEntry(atOnce) {           // step off our history entry, if we are on it
    pushed = false;
    if (backPending) { pushAfterBack = false; return; }       // our own step back is already under way
    if (traversing || !onEntry()) return;                    // so is the customer's (they pressed Back a moment ago)
    backPending = true;
    function stepBack() {
      backTimer = null;
      if (!onEntry()) { settleBack(); return; }
      try { window.history.back(); } catch (e) { settleBack(); }
    }
    if (atOnce) stepBack();                                  // nobody can have pressed anything yet (page load, cache restore)
    else backTimer = window.setTimeout(stepBack, 40);        // after a close: if the customer's own Back was already on its way, it wins
  }
  function cancelStepBack() {            // the page is being left: a late step back would undo that navigation
    if (backTimer) { window.clearTimeout(backTimer); backTimer = null; backPending = false; pushAfterBack = false; }
  }
  function leaveTo(url) {                // go to another page without leaving our history entry behind
    if (pushed && onEntry()) { pushed = false; window.location.replace(url); } else window.location.assign(url);
  }

  /* ---------- open and close ---------- */
  function focusables() {
    return [].slice.call(root.querySelectorAll('button:not([disabled]), select:not([disabled]), input:not([disabled]), a[href], [tabindex="0"]')).filter(function (el) {
      return el.getAttribute('tabindex') !== '-1' && el.getClientRects().length > 0 && window.getComputedStyle(el).visibility !== 'hidden' && !el.closest('[inert]');
    });
  }
  function inertOne(el) {
    if (el === host || el.nodeType !== 1 || el.hasAttribute('inert') || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(el.tagName)) return;
    el.setAttribute('inert', '');
    var rec = { el: el, hid: false, vis: '', pri: '' };
    outrank(rec);
    inerted.push(rec);
  }
  function hiddenByUs(el) { return el.style.getPropertyValue('visibility') === 'hidden' && el.style.getPropertyPriority('visibility') === 'important'; }
  function outrank(rec) {                // a widget pinned above everything (a review badge, a chat bubble) would sit on top of the dialog: hide it while the dialog is open
    try {
      if (rec.hid && hiddenByUs(rec.el)) return;             // still as we left it
      var cs = window.getComputedStyle(rec.el);
      if (cs.position === 'fixed' && parseInt(cs.zIndex, 10) >= +HOST_Z) {
        rec.vis = rec.el.style.getPropertyValue('visibility'); rec.pri = rec.el.style.getPropertyPriority('visibility');   // its own value, which it may have changed since we last looked
        rec.el.style.setProperty('visibility', 'hidden', 'important');
        rec.hid = true;
      } else {
        rec.hid = false;                                     // it restyled itself and no longer sits above the dialog: leave it alone
      }
    } catch (e) {}
  }
  function sweep() { if (isOpen) inerted.forEach(outrank); }     // such widgets are often styled a moment after they are added, so look again
  function sweepSoon() {
    sweepTimers.forEach(function (t) { clearTimeout(t); });
    sweepTimers = [300, 1200, 4000, 10000].map(function (ms) { return setTimeout(sweep, ms); });
  }
  function setInert(on) {
    var i;
    if (bodyWatch) { bodyWatch.disconnect(); bodyWatch = null; }
    if (on) {
      inerted = [];
      for (i = 0; i < document.body.children.length; i++) inertOne(document.body.children[i]);
      if (window.MutationObserver) {     // widgets that other scripts add to <body> while the dialog is open
        bodyWatch = new MutationObserver(function (list) {
          list.forEach(function (m) { [].forEach.call(m.addedNodes, inertOne); });
          sweepSoon();
        });
        bodyWatch.observe(document.body, { childList: true });
      }
      sweepSoon();
    } else {
      sweepTimers.forEach(function (t) { clearTimeout(t); });
      sweepTimers = [];
      for (i = 0; i < inerted.length; i++) {
        inerted[i].el.removeAttribute('inert');
        if (inerted[i].hid && hiddenByUs(inerted[i].el)) {   // undo only what is still ours: a widget that changed its own visibility meanwhile keeps it
          if (inerted[i].vis) inerted[i].el.style.setProperty('visibility', inerted[i].vis, inerted[i].pri);
          else inerted[i].el.style.removeProperty('visibility');
        }
      }
      inerted = [];
    }
  }
  function open() {
    if (isOpen || failed || !M) return;
    lastFocus = document.activeElement;
    isOpen = true;
    try {
      var ink = (window.getComputedStyle(host).getPropertyValue('--bbvb-ink') || '').trim();
      if (/^#[0-9a-f]{3,8}$/i.test(ink)) INK = ink;
    } catch (e) {}
    savedOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    host.style.display = 'block';
    setInert(true);
    root.hidden = false;
    ['.bbvb-steps', '.bbvb-progress', '.bbvb-main', '.bbvb-side', '.bbvb-foot'].forEach(function (s) { $(s).innerHTML = ''; });
    render('jump');
    pushEntry();
  }
  function close(fromHistory, force) {
    if (!isOpen) return;
    if (S && S.busy && !force) return;                       // wait for the cart request
    isOpen = false;
    root.hidden = true;
    host.style.display = 'none';
    document.documentElement.style.overflow = savedOverflow || '';
    setInert(false);
    if (S && (S.done || force)) S = fresh();                 // the build is in the cart: the next one starts clean
    else if (S) { S.sheet = false; S.error = null; }
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    if (fromHistory) pushed = false; else dropEntry();
  }
  function onEscape() {
    if (S && S.sheet) act('sheet'); else close();
  }
  function requestOpen(btn) {
    if (failed || isOpen) return;
    if (btn) btn.setAttribute('aria-busy', 'true');
    var gen = generation;
    var slow = window.setTimeout(function () {               // nothing may leave the customer waiting on a dead button
      if (gen === generation && !isOpen && !failed) fallback('the Configurator took too long to load');
    }, T_OPEN);
    Promise.all([ready, cssReady]).then(function (r) {
      window.clearTimeout(slow);
      if (btn) btn.removeAttribute('aria-busy');
      if (gen === generation && r[0] && r[1] && !failed) open();
    });
  }

  /* ---------- the dialog shell (inside the shadow root) ---------- */
  var SHELL =
    '<div class="bbvb" role="dialog" aria-modal="true" aria-labelledby="bbvb-title" tabindex="-1" hidden>' +
      '<div class="bbvb-head">' +
        '<div class="bbvb-brand"><span class="bbvb-brand__eyebrow"></span><span class="bbvb-brand__title" id="bbvb-title"></span></div>' +
        '<ol class="bbvb-steps"></ol>' +
        '<button type="button" class="bbvb-close" data-a="close" aria-label="Close"><span>Close</span> &#x2715;</button>' +
        '<div class="bbvb-progress"></div>' +
      '</div>' +
      '<div class="bbvb-body">' +
        '<div class="bbvb-main"></div>' +
        '<button type="button" class="bbvb-scrim" data-a="sheet" aria-label="Close the summary" tabindex="-1"></button>' +
        '<aside class="bbvb-side" aria-label="Your vanity"></aside>' +
      '</div>' +
      '<div class="bbvb-foot"></div>' +
    '</div>';

  function buildHost() {
    var gen = generation;
    host = document.createElement('div');
    host.setAttribute('data-bbvb-host', '');
    host.style.cssText = 'position:fixed;top:0;right:0;bottom:0;left:0;z-index:' + HOST_Z + ';display:none;';
    var cols = SET.colors || {};
    if (cols.ink) host.style.setProperty('--bbvb-ink', cols.ink);
    if (cols.accent) host.style.setProperty('--bbvb-accent', cols.accent);
    if (cols.paper) host.style.setProperty('--bbvb-paper', cols.paper);
    shadow = host.attachShadow({ mode: 'open' });
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    cssReady = new Promise(function (res) {
      link.addEventListener('load', function () { res(true); });
      link.addEventListener('error', function () {           // without its styles the dialog must not open at all
        res(false);
        if (gen === generation) fallback('the stylesheet did not load');
      });
    });
    link.href = CFG.css_url;
    shadow.appendChild(link);
    var wrap = document.createElement('div');
    wrap.innerHTML = SHELL;
    root = wrap.firstChild;
    shadow.appendChild(root);
    document.body.appendChild(host);

    root.addEventListener('click', function (e) {
      var nav = e.target.closest('[data-nav]');
      if (nav && root.contains(nav)) {
        if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;   // new tab or window: leave it to the browser
        e.preventDefault(); leaveTo(nav.getAttribute('href')); return;
      }
      var el = e.target.closest('[data-a]');
      if (!el || !root.contains(el) || el.disabled || el.tagName === 'SELECT' || el.tagName === 'INPUT') return;
      var name = el.getAttribute('data-a');
      if (name === 'close') { close(); return; }
      act(name, el.getAttribute('data-v'));
    });
    root.addEventListener('change', function (e) {
      var el = e.target;
      if (!el || !el.getAttribute || !el.getAttribute('data-a')) return;
      if (el.tagName === 'SELECT') act(el.getAttribute('data-a'), el.value);
      else if (el.tagName === 'INPUT' && el.type === 'checkbox') act(el.getAttribute('data-a'), el.checked);
    });
    root.addEventListener('error', function (e) {            // a missing image falls back to the colour or glyph behind it
      if (e.target && e.target.tagName === 'IMG') e.target.setAttribute('data-err', '1');
    }, true);
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.stopPropagation(); onEscape(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) { e.preventDefault(); return; }
      var cur = shadow.activeElement, at = f.indexOf(cur);
      if (e.shiftKey && at <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && (at === f.length - 1 || (at < 0 && cur !== shadow.getElementById('bbvb-h')))) { e.preventDefault(); f[0].focus(); }
    });
  }

  /* ---------- start-up, fallback, theme editor ---------- */
  function prehideCss() { return FORM_BLOCK + (nativeEl ? '[data-bbvb-native]' : '') + '{display:none !important}'; }
  function removePrehide() {
    [].forEach.call(document.querySelectorAll('style[data-bbvb-prehide]'), function (s) { if (s.parentNode) s.parentNode.removeChild(s); });
  }
  function setPrehide() {                // hide the standard form, and only the one this page's product uses
    if (!SET.replace_buy_buttons || failed) { removePrehide(); return; }
    var styles = document.querySelectorAll('style[data-bbvb-prehide]'), i;
    if (!styles.length) {
      var st = document.createElement('style');
      st.setAttribute('data-bbvb-prehide', '');
      document.head.appendChild(st);
      styles = [st];
    }
    for (i = 0; i < styles.length; i++) styles[i].textContent = prehideCss();
  }
  function editorNote(text, bad) {
    if (!noteEl) return;
    noteEl.textContent = text;
    noteEl.hidden = !text;
    noteEl.classList.toggle('is-bad', !!bad);
  }
  function dressLaunch() {               // the launch card: a few counts and a slow strip of cabinet finishes, once the range data is in
    if (!launchEl || !M || !LIB) return;
    var stats = launchEl.querySelector('[data-bbvb-stats]'), strip = launchEl.querySelector('[data-bbvb-strip]');
    try {
      if (stats && !stats.firstChild) {
        var fams = {}, parts = M.sizes.length > 1 ? [M.sizes.length + ' sizes'] : [];
        if (M.topIds.length > 2 && M.hasMoulded) parts.push(M.topIds.filter(function (t) { return topKind(t) !== 'n'; }).length + ' tops');
        if (M.fins.length > 1) parts.push(M.fins.length + ' finishes');
        M.picks.forEach(function (p) { if (p.items && p.items.length > 5) parts.push(p.items.length + ' ' + p.l.toLowerCase()); });
        if (!M.incBasin) { M.basins.forEach(function (b) { if (b.ok && !b.oos) fams[b.key] = 1; }); if (Object.keys(fams).length > 1) parts.push(Object.keys(fams).length + ' basins'); }
        stats.innerHTML = parts.map(function (p) { return '<span>' + esc(p) + '</span>'; }).join('');
        stats.hidden = !parts.length;
      }
      var pool = M.fins.length > 5 ? M.fins.map(function (i) { return LIB.fins[i]; }) : LIB.tops.filter(function (t, i) { return M.topIds.indexOf(t.g) > -1 && topColours(t.g).indexOf(i) > -1; });
      pool = pool.filter(function (f) { return !!f && !!f.f; });
      if (strip && !strip.firstChild && pool.length > 5) {
        var n = Math.min(pool.length, 16), step = pool.length / n, one = '', i, f;
        for (i = 0; i < n; i++) {
          f = pool[Math.floor(i * step)];
          one += '<span style="background:' + esc(f.bg || '#ddd') + '">' + img(sized(file(f.f), 120, 120), '') + '</span>';
        }
        strip.innerHTML = '<div class="bbvb-launch__track">' + one + one + '</div>';
        strip.hidden = false;
      }
    } catch (e) {}
  }
  function placeLaunch() {
    if (!launchEl || !document.documentElement.contains(launchEl)) {      // first run, or the theme editor re-rendered what held it
      launchEl = launchProto ? launchProto.cloneNode(true) : null;
      if (launchEl && sectionEl) sectionEl.insertBefore(launchEl, sectionEl.firstChild);
    }
    if (nativeEl) nativeEl.removeAttribute('data-bbvb-native');
    nativeEl = document.querySelector(FORM_BLOCK);
    if (nativeEl) nativeEl.setAttribute('data-bbvb-native', '');
    if (launchEl) {
      var slot = document.querySelector('[data-bbvb-launch]');
      if (slot) { if (launchEl.parentNode !== slot) slot.appendChild(launchEl); launchEl.classList.add('bbvb-launch--placed'); }
      else if (SET.replace_buy_buttons && nativeEl && nativeEl.parentNode) {
        if (launchEl.nextElementSibling !== nativeEl) nativeEl.parentNode.insertBefore(launchEl, nativeEl);
        launchEl.classList.add('bbvb-launch--placed');
      }
      launchEl.hidden = failed;
      dressLaunch();
    }
    setPrehide();
  }
  function fallback(reason) {            // the Configurator cannot run: hand the page back to the standard product form
    if (failed) return;
    failed = true;
    if (isOpen) close(false, true);
    removePrehide();
    if (launchEl) { launchEl.hidden = true; var b = launchEl.querySelector('[aria-busy]'); if (b) b.removeAttribute('aria-busy'); }
    editorNote('Configurator is not active on this product: ' + reason + '. The standard options and Add to cart are shown instead.', true);
    warn(reason + '. The standard options and Add to cart are shown instead.');
    if (readyResolve) { readyResolve(false); readyResolve = null; }
  }
  function teardown() {
    generation++;
    if (isOpen) close(false, true);
    if (launchEl && launchEl.parentNode && sectionEl && !sectionEl.contains(launchEl)) launchEl.parentNode.removeChild(launchEl);
    if (host && host.parentNode) host.parentNode.removeChild(host);
    if (nativeEl) nativeEl.removeAttribute('data-bbvb-native');
    removePrehide();                                         // the next init puts it back if the setting is still on
    host = shadow = root = null; launchEl = launchProto = noteEl = sectionEl = nativeEl = null;
    CFG = null; SET = {}; LIB = M = S = null; CAT = {}; failed = false;
    cssReady = Promise.resolve(true);
    if (readyResolve) readyResolve(false);
    ready = new Promise(function (res) { readyResolve = res; });
    if (window.BBVB) { window.BBVB.ready = ready; window.BBVB.started = false; }
  }
  function init(sec) {
    if (sectionEl) teardown();
    var gen = ++generation;
    sectionEl = sec;
    noteEl = sec.querySelector('[data-bbvb-editor-note]');
    launchEl = sec.querySelector('[data-bbvb-launch-block]');
    launchProto = launchEl ? launchEl.cloneNode(true) : null;
    var cfgEl = sec.querySelector('script[data-bbvb-config]');
    try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { CFG = null; }
    if (!CFG || !CFG.product || !CFG.routes) { CFG = CFG || { product: {}, routes: {} }; fallback('the section settings could not be read'); return; }
    SET = CFG.settings || {};
    MONEY = String(CFG.money_format || '${{amount}}').replace(/<[^>]*>/g, '');
    FILES = CFG.files_url || '';
    if (!FILES && CFG.product.image) FILES = String(CFG.product.image).split('?')[0].replace(/[^/]+$/, '');
    placeLaunch();
    window.BBVB.started = true;
    if (!CFG.data_url) { fallback('no range data file is set (the product has no Range metafield)'); return; }
    if (!window.fetch || !window.Promise || !document.body.attachShadow) { fallback('this browser is too old for the Configurator'); return; }
    buildHost();
    Promise.all([request(CFG.data_url, { credentials: 'omit' }, T_DATA), loadCatalogue()]).then(function (got) {
      if (gen !== generation || failed) return;
      var r = got[0];
      if (!r.okHttp || !r.data) throw new Error(r.network ? 'the range data file did not load in time' : 'the range data file was not found (' + r.status + ')');
      M = assemble(r.data);
      S = fresh();
      restore();
      dressLaunch();
      var meta = CFG.addons_meta || {};
      editorNote('Configurator is active on this product: ' + M.sizes.length + ' widths, ' + Object.keys(M.combos).length + ' size and bowl combinations, ' +
        Object.keys(CAT).length + ' add-on SKUs' + (meta.count ? ' from ' + meta.printed + ' of ' + meta.count + ' add-on products' : '') + '.', meta.count > meta.printed);
      if (readyResolve) { readyResolve(true); readyResolve = null; }
    }).catch(function (err) {
      if (gen !== generation) return;
      fallback(String((err && err.message) || err || 'the range data could not be loaded'));
    });
  }
  function boot() {
    if (onEntry()) dropEntry(true);                          // loaded on the dialog's own history entry (a reload while it was open)
    var sec = document.querySelector('[data-bbvb-section]');
    if (sec) init(sec);
  }

  window.BBVB = {
    version: VERSION, started: false, ready: ready,
    open: function () { requestOpen(null); }, close: function () { close(); },
    act: act, money: money,
    state: function () { return S; }, model: function () { return M; }, config: function () { return CFG; }, catalogue: function () { return CAT; },
    lines: function () { return M && S ? lines() : []; },
    totals: function () { return totals(M && S ? lines() : []); },
    payload: function (mode) { return M && S ? payload(mode) : { items: [] }; },
    problem: function (id) { return M && S ? problem(id) : ''; },
    activeSteps: function () { return M && S ? activeSteps() : []; },
    allowedBasins: function () { return M && S ? allowedBasins() : []; },
    isOpen: function () { return isOpen; }
  };

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-bbvb-open]') : null;
    if (!b) return;
    e.preventDefault();
    requestOpen(b);
  });
  document.addEventListener('keydown', function (e) {        // focus slipped out of the dialog (onto <body>): keep Escape and Tab working
    if (!isOpen || document.activeElement === host) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); onEscape(); }
    else if (e.key === 'Tab') { var f = focusables(); e.preventDefault(); if (f.length) f[e.shiftKey ? f.length - 1 : 0].focus(); }
  }, true);
  if (window.navigation && window.navigation.addEventListener) {   // where the browser tells us a Back/Forward has started
    window.navigation.addEventListener('navigate', function (e) { if (e && e.navigationType === 'traverse') traversing = true; });
    window.navigation.addEventListener('navigatesuccess', function () { traversing = false; });
    window.navigation.addEventListener('navigateerror', function () { traversing = false; });
  }
  window.addEventListener('popstate', function () {
    traversing = false;
    if (backPending) {                                       // the Back we asked for ourselves, or the customer's just ahead of it
      if (backTimer) { window.clearTimeout(backTimer); backTimer = null; }
      settleBack();
      return;
    }
    if (isOpen) {
      pushed = false;
      if (S && S.busy) pushEntry();                          // the cart request is out: stay open, keep our entry
      else close(true);
      return;
    }
    if (onEntry()) dropEntry(true);                          // Forward onto our entry with the dialog closed: step off it
  });
  window.addEventListener('beforeunload', cancelStepBack);
  window.addEventListener('pagehide', cancelStepBack);
  window.addEventListener('pageshow', function (e) {         // back from another page through the back/forward cache
    if (!e.persisted) return;
    traversing = false;
    if (isOpen) close(true, true);
    else if (M && S) {
      if (S.done || S.busy) S = fresh();
      else { S.ack = false; S.build = null; S.error = null; S.sheet = false; }
    }
    if (M && S && !started()) restore();                     // same as a fresh load: saved choices come back, the tick and build id do not
    if (onEntry()) dropEntry(true);
  });
  if (mq) {
    var onMq = function () { if (S && S.sheet && !mq.matches && root) { S.sheet = false; render(false); } };
    if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
  }
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target && e.target.querySelector ? e.target.querySelector('[data-bbvb-section]') : null;
    if (sec) { init(sec); return; }
    if (sectionEl && !failed) placeLaunch();                 // another section was re-rendered: the product form may be new
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (sectionEl && e.target && e.target.contains && e.target.contains(sectionEl)) teardown();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
